"use strict";

const ANALYSIS_DEFAULT_LANG = "en-GB";

const ANALYSIS_LANGS = [
  "ja-JP",
  "it-IT",
  "es-ES",
  "ru-RU",
  "fr-FR",
  "de-DE",
  "en-GB",
  "tr-TR",
  "zh-CN",
  "th-TH",
  "vi-VN",
  "ko-KR",
  "en-SG",
  "id-ID",
  "nl-NL"
];

const analysisTranslations = {
  "en-GB": {
    common: {
      loading: "Loading...",
      noData: "No data",
      all: "All",
      live: "Live",
      prematch: "Prematch",
      search: "Search",
      filter: "Filter",
      refresh: "Refresh",
      reset: "Reset",
      apply: "Apply",
      save: "Save",
      close: "Close",
      clear: "Clear",
      status: "Status",
      match: "Match",
      market: "Market",
      league: "League",
      bookmaker: "Bookmaker",
      bookmakers: "Bookmakers",
      updated: "Updated",
      time: "Time",
      date: "Date",
      home: "Home",
      away: "Away",
      score: "Score",
      odds: "Odds",
      oddsLabel: "Odds",
      trueOddsLabel: "True Odds",
      stake: "Stake",
      profit: "Profit",
      payout: "Payout",
      roi: "ROI",
      notes: "Notes",
      today: "Today",
      yesterday: "Yesterday",
      tomorrow: "Tomorrow",
      favorites: "Favorites",
      addFavorite: "Add favorite",
      removeFavorite: "Remove favorite",
      line: "Line",
      selection: "Selection",
      middle: "Middle",
      middleWindow: "Middle window",
      corridor: "Corridor",
      legs: "Legs",
      pick: "Pick",
      picks: "Picks",
      copied: "Copied"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Arbitrage",
      value: "Value Bets",
      notes: "Options"
    },
    header: {
      logout: "Logout",
      language: "Language"
    },
    sports: {
      football: "Football",
      tennis: "Tennis",
      basketball: "Basketball",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Track rapid odds movement across markets",
      highMove: "High Move",
      steamStrength: "Steam Strength",
      movePercent: "Move %",
      openingOdds: "Opening Odds",
      currentOdds: "Current Odds",
      directionUp: "Up",
      directionDown: "Down",
      directionFlat: "Flat",
      sharpSignal: "Sharp Signal",
      publicSignal: "Public Signal",
      confidence: "Confidence",
      marketType: "Market Type",
      overUnder: "Over/Under",
      handicap: "Handicap",
      moneyline: "Moneyline",
      noSteam: "No steam move found",
      tierYellow: "Yellow",
      tierOrange: "Orange",
      tierGreen: "Green",
      chipBettingSplits: "Betting splits",
      chipMovement: "Movement",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Yellow",
      signalLabelOrange: "Steam · Orange",
      signalLabelGreen: "Steam · Green",
      reasonYellow: "Public handle and bet share diverge; splits-only tier.",
      reasonOrange: "Splits plus confirmed odds movement.",
      reasonGreen: "Splits, movement, Pinnacle-confirmed EV row, and positive EV align.",
      splitsLabel: "Money",
      betsLabel: "Bets",
      splitsGapLabel: "Gap",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Movement",
      bettingSplitsLabel: "Betting splits",
      movementConfirmedLabel: "Movement confirmed",
      pinnacleConfirmedLabel: "Pinnacle confirmed",
      positiveEvLabel: "Positive EV",
      previewLabel: "Preview",
      previewReasonYellow: "Example: splits-only (yellow).",
      previewReasonOrange: "Example: splits plus movement (orange).",
      previewReasonGreen: "Example: full green alignment.",
      previewLeagueSplits: "Preview League — Splits",
      previewLeagueMove: "Preview League — Move",
      previewLeagueEv: "Preview League — EV",
      previewMatchSplits: "Mock United vs Preview City",
      previewMatchMove: "Line Move FC vs Steam Town",
      previewMatchEv: "Sharp Side vs Devig Athletic",
      previewBookA: "BetPreview",
      previewBookB: "MoveLine",
      previewBookC: "ConfirmBook",
      previewSplitsBookConsensus: "Consensus",
      previewSplitsBookMarket: "Market"
    },
    middles: {
      previewWindowThreeGoals: "3 goals",
      previewCorridorOnePt: "1.0 pt corridor",
      previewWindowRounds2122: "21–22 rounds",
      guaranteedProfit: "Guaranteed Profit",
      guaranteedBadge: "Guaranteed",
      keyNumbers: "Key numbers",
      largeGap: "Large gap",
      staleOdds: "Stale odds",
      highProbability: "High probability",
      liveGame: "Live",
      middleProbabilityLabel: "Hit probability",
      roiLabel: "Expected ROI",
      worstCase: "Worst case",
      bestCase: "Best case",
      breakEven: "Break-even",
      middleSize: "Middle size",
      middleWindow: "Win zone"
    },
    arbitrage: {
      title: "Arbitrage",
      subtitle: "Find risk-free opportunities",
      profitPercent: "Profit %",
      totalStake: "Total Stake",
      guaranteedProfit: "Guaranteed Profit",
      stakeSplit: "Stake Split",
      bestOdds: "Best Odds",
      opportunity: "Opportunity",
      noArb: "No arbitrage opportunities found",
      compareBookmakers: "Compare bookmakers",
      groupA: "Group A",
      groupB: "Group B",
      autoOn: "Auto ON",
      autoOff: "Auto OFF",
      autoOnShort: "Auto: ON",
      autoOffShort: "Auto: OFF",
      last: "Last",
      clearA: "Clear A",
      clearB: "Clear B",
      pause: "Pause",
      resume: "Resume",
      scan: "Scan",
      scanning: "Scanning...",
      selectBookmakers: "Select bookmakers...",
      swapGroups: "Swap A ↔ B",
      disconnected: "Disconnected",
      retainedData: "Retained data",
      liveFeed: "Live feed",
      freshBatch: "Fresh",
      apiDisconnected: "API disconnected",
      backendError: "Backend reported an error",
      fetchError: "Fetch error",
      noArbitrageInPool: "No arbitrage in pool"
    },
    value: {
      title: "Value Bets",
      subtitle: "Compare market price with fair probability",
      valuePercent: "Value %",
      fairOdds: "Fair Odds",
      edge: "Edge",
      expectedValue: "Expected Value",
      trueOdds: "True Odds",
      modelOdds: "Model Odds",
      recommendation: "Recommendation",
      strongValue: "Strong Value",
      mediumValue: "Medium Value",
      lowValue: "Low Value",
      noValue: "No value bets found"
    },
    stats: {
      title: "Options",
      subtitle: "Quick calculators and display settings",
      totalBets: "Total Bets",
      winRate: "Win Rate",
      averageOdds: "Average Odds",
      netProfit: "Net Profit",
      performance: "Performance",
      history: "History",
      recentActivity: "Recent Activity",
      emptyNotes: "No notes available"
    },
    marketTerms: {
      firstHalf: "First half",
      secondHalf: "Second half",
      first10Min: "First 10 minutes",
      first15Min: "First 15 minutes",
      thirtyMinutes: "30 minutes",
      sixtyMinutes: "60 minutes",
      corners: "Corners",
      teamTotal: "Team Total",
      exactGoals: "Exact goals",
      drawNoBet: "Draw no bet",
      doubleChance: "Double chance",
      winToNil: "Win to nil",
      oddEven: "Odd / even",
      handicapResult: "Handicap result",
      europeanHandicap: "European handicap",
      firstToScore: "First to score",
      scoreFirst: "Score first",
      scoreLast: "Score last",
      bothHalves: "Both halves",
      eitherHalf: "Either half",
      totalGoalsAndBtts: "Total goals / both teams to score",
      homeTeam: "Home team",
      awayTeam: "Away team",
      raceTo: "Race to",
      goals: "Goals",
      cards: "Cards",
      correctScore: "Correct score",
      winningMargin: "Winning margin",
      qualify: "Qualify",
      trophy: "Trophy",
      outrightWinner: "Outright winner",
      cleanSheet: "Clean sheet",
      firstGoalMethod: "First goal method",
      scoringDraw: "Scoring draw",
      goalLine: "Goal line",
      teamCards: "Team cards",
      teamCorners: "Team corners",
      totalCorners: "Total corners",
      totalCards: "Total cards",
      bookingPoints: "Booking points",
      penaltyAwarded: "Penalty awarded",
      shotsOnTarget: "Shots on target",
      firstGoal: "First goal",
      lastGoal: "Last goal",
      homeCleanSheet: "Home clean sheet",
      awayCleanSheet: "Away clean sheet",
      gameTotal: "Game Total"
    },
    periodScopes: {
      fullTime: "Full Time",
      firstHalf: "1st Half",
      secondHalf: "2nd Half",
      firstQuarter: "Q1",
      secondQuarter: "Q2",
      firstSet: "Set 1",
      secondSet: "Set 2",
      first10Min: "First 10 Minutes",
      first15Min: "First 15 Minutes",
      thirtyMinutes: "30 Minutes",
      sixtyMinutes: "60 Minutes"
    }
  },

  "ja-JP": {
    common: {
      loading: "読み込み中...",
      noData: "データがありません",
      all: "すべて",
      live: "ライブ",
      prematch: "試合前",
      search: "検索",
      filter: "フィルター",
      refresh: "更新",
      reset: "リセット",
      apply: "適用",
      save: "保存",
      close: "閉じる",
      clear: "クリア",
      status: "状態",
      match: "試合",
      market: "マーケット",
      league: "リーグ",
      bookmaker: "ブックメーカー",
      bookmakers: "ブックメーカー",
      updated: "更新済み",
      time: "時間",
      date: "日付",
      home: "ホーム",
      away: "アウェイ",
      score: "スコア",
      odds: "オッズ",
      oddsLabel: "オッズ",
      trueOddsLabel: "真のオッズ",
      stake: "賭け金",
      profit: "利益",
      payout: "払戻金",
      roi: "ROI",
      notes: "メモ",
      today: "今日",
      yesterday: "昨日",
      tomorrow: "明日",
      favorites: "お気に入り",
      addFavorite: "お気に入りに追加",
      removeFavorite: "お気に入りを解除",
      line: "ライン",
      selection: "選択",
      middle: "ミドル",
      middleWindow: "ミドル幅",
      corridor: "コリドー",
      legs: "レッグ",
      pick: "ピック",
      picks: "ピック",
      copied: "コピーしました"
    },
    tabs: {
      steam: "スチームムーブ",
      arb: "アービトラージ",
      value: "バリューベット",
      notes: "メモ"
    },
    header: {
      logout: "ログアウト",
      language: "言語"
    },
    sports: {
      football: "サッカー",
      tennis: "テニス",
      basketball: "バスケット",
      esports: "eスポーツ"
    },
    steam: {
      title: "スチームムーブ",
      subtitle: "各市場での急速なオッズ変動を追跡",
      highMove: "高変動",
      steamStrength: "スチーム強度",
      movePercent: "変動 %",
      openingOdds: "開始オッズ",
      currentOdds: "現在のオッズ",
      directionUp: "上昇",
      directionDown: "下降",
      directionFlat: "横ばい",
      sharpSignal: "シャープシグナル",
      publicSignal: "パブリックシグナル",
      confidence: "信頼度",
      marketType: "マーケットタイプ",
      overUnder: "オーバー/アンダー",
      handicap: "ハンディキャップ",
      moneyline: "マネーライン",
      noSteam: "スチームムーブが見つかりません",
      tierYellow: "イエロー",
      tierOrange: "オレンジ",
      tierGreen: "グリーン",
      chipBettingSplits: "ベッティングスプリット",
      chipMovement: "動き",
      chipPinnacle: "ピナクル",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "スチーム · イエロー",
      signalLabelOrange: "スチーム · オレンジ",
      signalLabelGreen: "スチーム · グリーン",
      reasonYellow: "ハンドルと投票割合が乖離；スプリットのみのティア。",
      reasonOrange: "スプリットに加え、オッズの動きを確認。",
      reasonGreen: "スプリット、動き、ピナクル確認のEV行、正のEVが一致。",
      splitsLabel: "マネー",
      betsLabel: "ベット数",
      splitsGapLabel: "ギャップ",
      sharpDevigLabel: "シャープ / デビッグ",
      evLabel: "EV",
      movementLabel: "動き",
      bettingSplitsLabel: "ベッティングスプリット",
      movementConfirmedLabel: "動き確認済み",
      pinnacleConfirmedLabel: "ピナクル確認済み",
      positiveEvLabel: "正のEV",
      previewLabel: "プレビュー",
      previewReasonYellow: "例：スプリットのみ（イエロー）。",
      previewReasonOrange: "例：スプリット＋動き（オレンジ）。",
      previewReasonGreen: "例：フルグリーン一致。"
    },
    arbitrage: {
      title: "アービトラージ",
      subtitle: "リスクなしの機会を見つける",
      profitPercent: "利益 %",
      totalStake: "合計賭け金",
      guaranteedProfit: "確定利益",
      stakeSplit: "賭け金配分",
      bestOdds: "最高オッズ",
      opportunity: "機会",
      noArb: "アービトラージの機会が見つかりません",
      compareBookmakers: "ブックメーカー比較",
      groupA: "グループ A",
      groupB: "グループ B",
      autoOn: "自動 ON",
      autoOff: "自動 OFF",
      autoOnShort: "自動: ON",
      autoOffShort: "自動: OFF",
      last: "最終",
      clearA: "Aをクリア",
      clearB: "Bをクリア",
      pause: "一時停止",
      resume: "再開",
      scan: "スキャン",
      scanning: "スキャン中...",
      selectBookmakers: "ブックメーカーを選択...",
      swapGroups: "A ↔ B 入替",
      disconnected: "切断",
      retainedData: "保持データ",
      liveFeed: "ライブフィード",
      freshBatch: "最新",
      apiDisconnected: "API切断",
      backendError: "バックエンドエラー",
      fetchError: "取得エラー",
      noArbitrageInPool: "プールにアービトラージなし"
    },
    value: {
      title: "バリューベット",
      subtitle: "市場価格と適正確率を比較",
      valuePercent: "価値 %",
      fairOdds: "適正オッズ",
      edge: "優位性",
      expectedValue: "期待値",
      trueOdds: "真のオッズ",
      modelOdds: "モデルオッズ",
      recommendation: "推奨",
      strongValue: "強いバリュー",
      mediumValue: "中程度のバリュー",
      lowValue: "低いバリュー",
      noValue: "バリューベットが見つかりません"
    },
    stats: {
      title: "メモ",
      subtitle: "追跡とパフォーマンス概要",
      totalBets: "総ベット数",
      winRate: "勝率",
      averageOdds: "平均オッズ",
      netProfit: "純利益",
      performance: "パフォーマンス",
      history: "履歴",
      recentActivity: "最近のアクティビティ",
      emptyNotes: "メモはありません"
    },
    marketTerms: {
      firstHalf: "前半",
      secondHalf: "後半",
      first10Min: "開始10分",
      first15Min: "開始15分",
      thirtyMinutes: "30分",
      sixtyMinutes: "60分",
      corners: "コーナー",
      teamTotal: "チームトータル",
      exactGoals: "正確な得点数",
      drawNoBet: "ドローなし",
      doubleChance: "ダブルチャンス",
      winToNil: "無失点勝利",
      oddEven: "奇数/偶数",
      handicapResult: "ハンディ結果",
      europeanHandicap: "ヨーロピアンハンディ",
      firstToScore: "先制",
      scoreFirst: "先制得点",
      scoreLast: "最終得点",
      bothHalves: "両ハーフ",
      eitherHalf: "いずれかのハーフ",
      totalGoalsAndBtts: "総得点 / 両チーム得点",
      homeTeam: "ホーム",
      awayTeam: "アウェイ",
      raceTo: "先取り",
      goals: "ゴール",
      cards: "カード",
      correctScore: "正確スコア",
      winningMargin: "勝敗差",
      qualify: "予選突破",
      trophy: "トロフィー",
      outrightWinner: "アウトライト優勝",
      cleanSheet: "無失点",
      firstGoalMethod: "先制点の方式",
      scoringDraw: "両得点の引分",
      goalLine: "ゴールライン",
      teamCards: "チームカード",
      teamCorners: "チームコーナー",
      totalCorners: "コーナー合計",
      totalCards: "カード合計",
      bookingPoints: "ブッキングポイント",
      penaltyAwarded: "PK判定",
      shotsOnTarget: "枠内シュート",
      firstGoal: "先制点",
      lastGoal: "最終点",
      homeCleanSheet: "ホーム無失点",
      awayCleanSheet: "アウェイ無失点",
      gameTotal: "試合トータル"
    }
  },

  "it-IT": {
    common: {
      loading: "Caricamento...",
      noData: "Nessun dato",
      all: "Tutto",
      live: "Live",
      prematch: "Prepartita",
      search: "Cerca",
      filter: "Filtro",
      refresh: "Aggiorna",
      reset: "Reimposta",
      apply: "Applica",
      save: "Salva",
      close: "Chiudi",
      clear: "Cancella",
      status: "Stato",
      match: "Partita",
      market: "Mercato",
      league: "Lega",
      bookmaker: "Bookmaker",
      bookmakers: "Bookmaker",
      updated: "Aggiornato",
      time: "Ora",
      date: "Data",
      home: "Casa",
      away: "Trasferta",
      score: "Punteggio",
      odds: "Quote",
      oddsLabel: "Quote",
      trueOddsLabel: "Quote Reali",
      stake: "Puntata",
      profit: "Profitto",
      payout: "Pagamento",
      roi: "ROI",
      notes: "Note",
      today: "Oggi",
      yesterday: "Ieri",
      tomorrow: "Domani",
      favorites: "Preferiti",
      addFavorite: "Aggiungi ai preferiti",
      removeFavorite: "Rimuovi dai preferiti",
      line: "Linea",
      selection: "Selezione",
      middle: "Middle",
      middleWindow: "Finestra middle",
      corridor: "Corridoio",
      legs: "Esiti",
      pick: "Scelta",
      picks: "Scelte",
      copied: "Copiato"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Arbitraggio",
      value: "Scommesse di Valore",
      notes: "Note"
    },
    header: {
      logout: "Esci",
      language: "Lingua"
    },
    sports: {
      football: "Calcio",
      tennis: "Tennis",
      basketball: "Basket",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Monitora i rapidi movimenti delle quote nei mercati",
      highMove: "Movimento Alto",
      steamStrength: "Forza Steam",
      movePercent: "Movimento %",
      openingOdds: "Quote Iniziali",
      currentOdds: "Quote Attuali",
      directionUp: "Su",
      directionDown: "Giù",
      directionFlat: "Stabile",
      sharpSignal: "Segnale Sharp",
      publicSignal: "Segnale Pubblico",
      confidence: "Affidabilità",
      marketType: "Tipo di Mercato",
      overUnder: "Over/Under",
      handicap: "Handicap",
      moneyline: "Moneyline",
      noSteam: "Nessuno steam move trovato",
      tierYellow: "Giallo",
      tierOrange: "Arancione",
      tierGreen: "Verde",
      chipBettingSplits: "Split sulle scommesse",
      chipMovement: "Movimento",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Giallo",
      signalLabelOrange: "Steam · Arancione",
      signalLabelGreen: "Steam · Verde",
      reasonYellow: "Volume gestito e quote delle scommesse divergono; solo split.",
      reasonOrange: "Split più movimento confermato della quota.",
      reasonGreen: "Split, movimento, riga EV confermata Pinnacle e EV positiva allineati.",
      splitsLabel: "Denaro",
      betsLabel: "Scommesse",
      splitsGapLabel: "Gap",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Movimento",
      bettingSplitsLabel: "Split sulle scommesse",
      movementConfirmedLabel: "Movimento confermato",
      pinnacleConfirmedLabel: "Pinnacle confermato",
      positiveEvLabel: "EV positivo",
      previewLabel: "Anteprima",
      previewReasonYellow: "Esempio: solo split (giallo).",
      previewReasonOrange: "Esempio: split più movimento (arancione).",
      previewReasonGreen: "Esempio: allineamento verde completo."
    },
    arbitrage: {
      title: "Arbitraggio",
      subtitle: "Trova opportunità senza rischio",
      profitPercent: "Profitto %",
      totalStake: "Puntata Totale",
      guaranteedProfit: "Profitto Garantito",
      stakeSplit: "Divisione Puntata",
      bestOdds: "Migliori Quote",
      opportunity: "Opportunità",
      noArb: "Nessuna opportunità di arbitraggio trovata",
      compareBookmakers: "Confronta bookmaker",
      groupA: "Gruppo A",
      groupB: "Gruppo B",
      autoOn: "Auto ON",
      autoOff: "Auto OFF",
      autoOnShort: "Auto: ON",
      autoOffShort: "Auto: OFF",
      last: "Ultimo",
      clearA: "Cancella A",
      clearB: "Cancella B",
      pause: "Pausa",
      resume: "Riprendi",
      scan: "Scansiona",
      scanning: "Scansione...",
      selectBookmakers: "Seleziona bookmaker...",
      swapGroups: "Scambia A ↔ B",
      disconnected: "Disconnesso",
      retainedData: "Dati conservati",
      liveFeed: "Feed live",
      freshBatch: "Aggiornato",
      apiDisconnected: "API disconnessa",
      backendError: "Errore backend",
      fetchError: "Errore di recupero",
      noArbitrageInPool: "Nessun arbitraggio nel pool"
    },
    value: {
      title: "Scommesse di Valore",
      subtitle: "Confronta il prezzo di mercato con la probabilità equa",
      valuePercent: "Valore %",
      fairOdds: "Quote Eque",
      edge: "Vantaggio",
      expectedValue: "Valore Atteso",
      trueOdds: "Quote Reali",
      modelOdds: "Quote del Modello",
      recommendation: "Raccomandazione",
      strongValue: "Valore Alto",
      mediumValue: "Valore Medio",
      lowValue: "Valore Basso",
      noValue: "Nessuna scommessa di valore trovata"
    },
    stats: {
      title: "Note",
      subtitle: "Monitoraggio e panoramica delle prestazioni",
      totalBets: "Scommesse Totali",
      winRate: "Percentuale di Vittoria",
      averageOdds: "Quote Medie",
      netProfit: "Profitto Netto",
      performance: "Prestazione",
      history: "Cronologia",
      recentActivity: "Attività Recenti",
      emptyNotes: "Nessuna nota disponibile"
    },
    marketTerms: {
      firstHalf: "Primo tempo",
      secondHalf: "Secondo tempo",
      first10Min: "Primi 10 minuti",
      first15Min: "Primi 15 minuti",
      thirtyMinutes: "30 minuti",
      sixtyMinutes: "60 minuti",
      corners: "Calci d'angolo",
      teamTotal: "Totale squadra",
      exactGoals: "Gol esatti",
      drawNoBet: "Pareggio rimborsato",
      doubleChance: "Doppia chance",
      winToNil: "Vittoria a rete inviolata",
      oddEven: "Dispari / pari",
      handicapResult: "Risultato handicap",
      europeanHandicap: "Handicap europeo",
      firstToScore: "Prima a segnare",
      scoreFirst: "Segna per prima",
      scoreLast: "Segna per ultima",
      bothHalves: "Entrambi i tempi",
      eitherHalf: "Un tempo qualsiasi",
      totalGoalsAndBtts: "Totale gol / entrambe segnano",
      homeTeam: "Casa",
      awayTeam: "Trasferta",
      raceTo: "Corsa a",
      goals: "Gol",
      cards: "Cartellini",
      correctScore: "Risultato esatto",
      winningMargin: "Margine di vittoria",
      qualify: "Qualificazione",
      trophy: "Trofeo",
      outrightWinner: "Vincente assoluto",
      cleanSheet: "Porta inviolata",
      firstGoalMethod: "Modo primo gol",
      scoringDraw: "Pareggio con gol",
      goalLine: "Linea gol",
      teamCards: "Cartellini squadra",
      teamCorners: "Calci d'angolo squadra",
      totalCorners: "Totale calci d'angolo",
      totalCards: "Totale cartellini",
      bookingPoints: "Punti cartellini",
      penaltyAwarded: "Rigore assegnato",
      shotsOnTarget: "Tiri in porta",
      firstGoal: "Primo gol",
      lastGoal: "Ultimo gol",
      homeCleanSheet: "Casa porta inviolata",
      awayCleanSheet: "Trasferta porta inviolata",
      gameTotal: "Totale partita"
    }
  },

  "es-ES": {
    common: {
      loading: "Cargando...",
      noData: "Sin datos",
      all: "Todo",
      live: "En vivo",
      prematch: "Prepartido",
      search: "Buscar",
      filter: "Filtro",
      refresh: "Actualizar",
      reset: "Restablecer",
      apply: "Aplicar",
      save: "Guardar",
      close: "Cerrar",
      clear: "Limpiar",
      status: "Estado",
      match: "Partido",
      market: "Mercado",
      league: "Liga",
      bookmaker: "Casa de apuestas",
      bookmakers: "Casas de apuestas",
      updated: "Actualizado",
      time: "Hora",
      date: "Fecha",
      home: "Local",
      away: "Visitante",
      score: "Marcador",
      odds: "Cuotas",
      oddsLabel: "Cuotas",
      trueOddsLabel: "Cuotas Reales",
      stake: "Apuesta",
      profit: "Ganancia",
      payout: "Pago",
      roi: "ROI",
      notes: "Notas",
      today: "Hoy",
      yesterday: "Ayer",
      tomorrow: "Mañana",
      favorites: "Favoritos",
      addFavorite: "Añadir a favoritos",
      removeFavorite: "Quitar de favoritos",
      line: "Línea",
      selection: "Selección",
      middle: "Middle",
      middleWindow: "Ventana middle",
      corridor: "Corredor",
      legs: "Patas",
      pick: "Selección",
      picks: "Selecciones",
      copied: "Copiado"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Arbitraje",
      value: "Apuestas de Valor",
      notes: "Notas"
    },
    header: {
      logout: "Cerrar sesión",
      language: "Idioma"
    },
    sports: {
      football: "Fútbol",
      tennis: "Tenis",
      basketball: "Basket",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Sigue los rápidos movimientos de cuotas en los mercados",
      highMove: "Movimiento Alto",
      steamStrength: "Fuerza Steam",
      movePercent: "Movimiento %",
      openingOdds: "Cuotas Iniciales",
      currentOdds: "Cuotas Actuales",
      directionUp: "Sube",
      directionDown: "Baja",
      directionFlat: "Plano",
      sharpSignal: "Señal Sharp",
      publicSignal: "Señal Pública",
      confidence: "Confianza",
      marketType: "Tipo de Mercado",
      overUnder: "Más/Menos",
      handicap: "Hándicap",
      moneyline: "Moneyline",
      noSteam: "No se encontró steam move",
      tierYellow: "Amarillo",
      tierOrange: "Naranja",
      tierGreen: "Verde",
      chipBettingSplits: "Splits de apuestas",
      chipMovement: "Movimiento",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Amarillo",
      signalLabelOrange: "Steam · Naranja",
      signalLabelGreen: "Steam · Verde",
      reasonYellow: "El volumen manejado y las apuestas divergen; solo splits.",
      reasonOrange: "Splits más movimiento confirmado de cuotas.",
      reasonGreen: "Splits, movimiento, fila EV Pinnacle y EV positiva alineados.",
      splitsLabel: "Dinero",
      betsLabel: "Apuestas",
      splitsGapLabel: "Brecha",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Movimiento",
      bettingSplitsLabel: "Splits de apuestas",
      movementConfirmedLabel: "Movimiento confirmado",
      pinnacleConfirmedLabel: "Pinnacle confirmado",
      positiveEvLabel: "EV positivo",
      previewLabel: "Vista previa",
      previewReasonYellow: "Ejemplo: solo splits (amarillo).",
      previewReasonOrange: "Ejemplo: splits más movimiento (naranja).",
      previewReasonGreen: "Ejemplo: alineación verde completa."
    },
    arbitrage: {
      title: "Arbitraje",
      subtitle: "Encuentra oportunidades sin riesgo",
      profitPercent: "Ganancia %",
      totalStake: "Apuesta Total",
      guaranteedProfit: "Ganancia Garantizada",
      stakeSplit: "Distribución de Apuesta",
      bestOdds: "Mejores Cuotas",
      opportunity: "Oportunidad",
      noArb: "No se encontraron oportunidades de arbitraje",
      compareBookmakers: "Comparar bookmakers",
      groupA: "Grupo A",
      groupB: "Grupo B",
      autoOn: "Auto ON",
      autoOff: "Auto OFF",
      autoOnShort: "Auto: ON",
      autoOffShort: "Auto: OFF",
      last: "Último",
      clearA: "Limpiar A",
      clearB: "Limpiar B",
      pause: "Pausa",
      resume: "Reanudar",
      scan: "Escanear",
      scanning: "Escaneando...",
      selectBookmakers: "Selecciona bookmakers...",
      swapGroups: "Cambiar A ↔ B",
      disconnected: "Desconectado",
      retainedData: "Datos retenidos",
      liveFeed: "Feed en vivo",
      freshBatch: "Reciente",
      apiDisconnected: "API desconectada",
      backendError: "Error del servidor",
      fetchError: "Error de red",
      noArbitrageInPool: "Sin arbitrajes en el pool"
    },
    value: {
      title: "Apuestas de Valor",
      subtitle: "Compara el precio del mercado con la probabilidad justa",
      valuePercent: "Valor %",
      fairOdds: "Cuotas Justas",
      edge: "Ventaja",
      expectedValue: "Valor Esperado",
      trueOdds: "Cuotas Reales",
      modelOdds: "Cuotas del Modelo",
      recommendation: "Recomendación",
      strongValue: "Valor Alto",
      mediumValue: "Valor Medio",
      lowValue: "Valor Bajo",
      noValue: "No se encontraron apuestas de valor"
    },
    stats: {
      title: "Notas",
      subtitle: "Seguimiento y resumen del rendimiento",
      totalBets: "Apuestas Totales",
      winRate: "Tasa de Victoria",
      averageOdds: "Cuotas Promedio",
      netProfit: "Ganancia Neta",
      performance: "Rendimiento",
      history: "Historial",
      recentActivity: "Actividad Reciente",
      emptyNotes: "No hay notas disponibles"
    },
    marketTerms: {
      firstHalf: "Primera parte",
      secondHalf: "Segunda parte",
      first10Min: "Primeros 10 minutos",
      first15Min: "Primeros 15 minutos",
      thirtyMinutes: "30 minutos",
      sixtyMinutes: "60 minutos",
      corners: "Córners",
      teamTotal: "Total de equipo",
      exactGoals: "Goles exactos",
      drawNoBet: "Empate anula apuesta",
      doubleChance: "Doble oportunidad",
      winToNil: "Victoria a cero",
      oddEven: "Impar / par",
      handicapResult: "Resultado con hándicap",
      europeanHandicap: "Hándicap europeo",
      firstToScore: "Primera en marcar",
      scoreFirst: "Marca primero",
      scoreLast: "Marca último",
      bothHalves: "Ambas partes",
      eitherHalf: "Cualquier parte",
      totalGoalsAndBtts: "Total goles / ambos marcan",
      homeTeam: "Local",
      awayTeam: "Visitante",
      raceTo: "Carrera a",
      goals: "Goles",
      cards: "Tarjetas",
      correctScore: "Marcador exacto",
      winningMargin: "Margen de victoria",
      qualify: "Clasificar",
      trophy: "Trofeo",
      outrightWinner: "Ganador absoluto",
      cleanSheet: "Portería a cero",
      firstGoalMethod: "Modo del primer gol",
      scoringDraw: "Empate con goles",
      goalLine: "Línea de goles",
      teamCards: "Tarjetas del equipo",
      teamCorners: "Córners del equipo",
      totalCorners: "Total córners",
      totalCards: "Total tarjetas",
      bookingPoints: "Puntos de tarjetas",
      penaltyAwarded: "Penalti señalado",
      shotsOnTarget: "Disparos a puerta",
      firstGoal: "Primer gol",
      lastGoal: "Último gol",
      homeCleanSheet: "Portería a cero local",
      awayCleanSheet: "Portería a cero visitante",
      gameTotal: "Total del partido"
    }
  },

  "ru-RU": {
    common: {
      loading: "Загрузка...",
      noData: "Нет данных",
      all: "Все",
      live: "Live",
      prematch: "Прематч",
      search: "Поиск",
      filter: "Фильтр",
      refresh: "Обновить",
      reset: "Сбросить",
      apply: "Применить",
      save: "Сохранить",
      close: "Закрыть",
      clear: "Очистить",
      status: "Статус",
      match: "Матч",
      market: "Рынок",
      league: "Лига",
      bookmaker: "Букмекер",
      bookmakers: "Букмекеры",
      updated: "Обновлено",
      time: "Время",
      date: "Дата",
      home: "Хозяева",
      away: "Гости",
      score: "Счет",
      odds: "Коэффициенты",
      oddsLabel: "Коэффициенты",
      trueOddsLabel: "Истинные Коэффициенты",
      stake: "Ставка",
      profit: "Прибыль",
      payout: "Выплата",
      roi: "ROI",
      notes: "Заметки",
      today: "Сегодня",
      yesterday: "Вчера",
      tomorrow: "Завтра",
      favorites: "Избранное",
      addFavorite: "В избранное",
      removeFavorite: "Убрать из избранного",
      line: "Линия",
      selection: "Исход",
      middle: "Мидл",
      middleWindow: "Окно мидла",
      corridor: "Коридор",
      legs: "Плечи",
      pick: "Выбор",
      picks: "Выборы",
      copied: "Скопировано"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Арбитраж",
      value: "Валуйные ставки",
      notes: "Заметки"
    },
    header: {
      logout: "Выйти",
      language: "Язык"
    },
    sports: {
      football: "Футбол",
      tennis: "Теннис",
      basketball: "Баскет",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Отслеживайте быстрые изменения коэффициентов на рынках",
      highMove: "Высокое Движение",
      steamStrength: "Сила Steam",
      movePercent: "Движение %",
      openingOdds: "Начальные Коэффициенты",
      currentOdds: "Текущие Коэффициенты",
      directionUp: "Вверх",
      directionDown: "Вниз",
      directionFlat: "Без изменений",
      sharpSignal: "Sharp Сигнал",
      publicSignal: "Публичный Сигнал",
      confidence: "Уверенность",
      marketType: "Тип Рынка",
      overUnder: "Тотал Больше/Меньше",
      handicap: "Фора",
      moneyline: "Moneyline",
      noSteam: "Steam move не найден",
      tierYellow: "Жёлтый",
      tierOrange: "Оранжевый",
      tierGreen: "Зелёный",
      chipBettingSplits: "Сплиты по ставкам",
      chipMovement: "Движение",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Жёлтый",
      signalLabelOrange: "Steam · Оранжевый",
      signalLabelGreen: "Steam · Зелёный",
      reasonYellow: "Расхождение объёма и доли ставок; только сплиты.",
      reasonOrange: "Сплиты плюс подтверждённое движение коэффициента.",
      reasonGreen: "Сплиты, движение, строка EV Pinnacle и положительный EV согласованы.",
      splitsLabel: "Деньги",
      betsLabel: "Ставки",
      splitsGapLabel: "Разрыв",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Движение",
      bettingSplitsLabel: "Сплиты по ставкам",
      movementConfirmedLabel: "Движение подтверждено",
      pinnacleConfirmedLabel: "Pinnacle подтверждён",
      positiveEvLabel: "Положительный EV",
      previewLabel: "Превью",
      previewReasonYellow: "Пример: только сплиты (жёлтый).",
      previewReasonOrange: "Пример: сплиты и движение (оранжевый).",
      previewReasonGreen: "Пример: полное зелёное совпадение."
    },
    arbitrage: {
      title: "Арбитраж",
      subtitle: "Найдите безрисковые возможности",
      profitPercent: "Прибыль %",
      totalStake: "Общая Ставка",
      guaranteedProfit: "Гарантированная Прибыль",
      stakeSplit: "Распределение Ставки",
      bestOdds: "Лучшие Коэффициенты",
      opportunity: "Возможность",
      noArb: "Арбитражные возможности не найдены",
      compareBookmakers: "Сравнить букмекеров",
      groupA: "Группа A",
      groupB: "Группа B",
      autoOn: "Авто ON",
      autoOff: "Авто OFF",
      autoOnShort: "Авто: ON",
      autoOffShort: "Авто: OFF",
      last: "Последнее",
      clearA: "Очистить A",
      clearB: "Очистить B",
      pause: "Пауза",
      resume: "Продолжить",
      scan: "Сканировать",
      scanning: "Сканирование...",
      selectBookmakers: "Выберите букмекеров...",
      swapGroups: "Поменять A ↔ B",
      disconnected: "Нет соединения",
      retainedData: "Сохранённые данные",
      liveFeed: "Живой поток",
      freshBatch: "Свежее",
      apiDisconnected: "API недоступно",
      backendError: "Ошибка сервера",
      fetchError: "Ошибка загрузки",
      noArbitrageInPool: "Нет вилок в пуле"
    },
    value: {
      title: "Валуйные ставки",
      subtitle: "Сравните рыночную цену со справедливой вероятностью",
      valuePercent: "Валуй %",
      fairOdds: "Справедливые Коэффициенты",
      edge: "Преимущество",
      expectedValue: "Ожидаемое Значение",
      trueOdds: "Истинные Коэффициенты",
      modelOdds: "Коэффициенты Модели",
      recommendation: "Рекомендация",
      strongValue: "Сильный Валуй",
      mediumValue: "Средний Валуй",
      lowValue: "Низкий Валуй",
      noValue: "Валуйные ставки не найдены"
    },
    stats: {
      title: "Заметки",
      subtitle: "Отслеживание и обзор производительности",
      totalBets: "Всего Ставок",
      winRate: "Процент Побед",
      averageOdds: "Средние Коэффициенты",
      netProfit: "Чистая Прибыль",
      performance: "Производительность",
      history: "История",
      recentActivity: "Недавняя Активность",
      emptyNotes: "Заметок нет"
    },
    marketTerms: {
      firstHalf: "1-й тайм",
      secondHalf: "2-й тайм",
      first10Min: "Первые 10 минут",
      first15Min: "Первые 15 минут",
      thirtyMinutes: "30 минут",
      sixtyMinutes: "60 минут",
      corners: "Угловые",
      teamTotal: "Инд. тотал команды",
      exactGoals: "Точное число голов",
      drawNoBet: "Победа без ничьей",
      doubleChance: "Двойной шанс",
      winToNil: "Победа на ноль",
      oddEven: "Нечёт / чёт",
      handicapResult: "Исход с форой",
      europeanHandicap: "Европейская фора",
      firstToScore: "Кто забьёт первым",
      scoreFirst: "Первый гол",
      scoreLast: "Последний гол",
      bothHalves: "Оба тайма",
      eitherHalf: "Любой тайм",
      totalGoalsAndBtts: "Тотал голов / обе забьют",
      homeTeam: "Хозяева",
      awayTeam: "Гости",
      raceTo: "Гонка до",
      goals: "Голы",
      cards: "Карточки",
      correctScore: "Точный счёт",
      winningMargin: "Маржа победы",
      qualify: "Квалификация",
      trophy: "Кубок",
      outrightWinner: "Победитель (outright)",
      cleanSheet: "Сухой матч",
      firstGoalMethod: "Способ первого гола",
      scoringDraw: "Ничья с голами",
      goalLine: "Голевая линия",
      teamCards: "Карточки команды",
      teamCorners: "Угловые команды",
      totalCorners: "Тотал угловых",
      totalCards: "Тотал карточек",
      bookingPoints: "Очки за карточки",
      penaltyAwarded: "Пенальти назначен",
      shotsOnTarget: "Удары в створ",
      firstGoal: "Первый гол",
      lastGoal: "Последний гол",
      homeCleanSheet: "Сухой матч хозяев",
      awayCleanSheet: "Сухой матч гостей",
      gameTotal: "Тотал матча"
    }
  },

  "fr-FR": {
    common: {
      loading: "Chargement...",
      noData: "Aucune donnée",
      all: "Tout",
      live: "Live",
      prematch: "Pré-match",
      search: "Rechercher",
      filter: "Filtre",
      refresh: "Actualiser",
      reset: "Réinitialiser",
      apply: "Appliquer",
      save: "Enregistrer",
      close: "Fermer",
      clear: "Effacer",
      status: "Statut",
      match: "Match",
      market: "Marché",
      league: "Ligue",
      bookmaker: "Bookmaker",
      bookmakers: "Bookmakers",
      updated: "Mis à jour",
      time: "Heure",
      date: "Date",
      home: "Domicile",
      away: "Extérieur",
      score: "Score",
      odds: "Cotes",
      oddsLabel: "Cotes",
      trueOddsLabel: "Cotes Réelles",
      stake: "Mise",
      profit: "Profit",
      payout: "Paiement",
      roi: "ROI",
      notes: "Notes",
      today: "Aujourd'hui",
      yesterday: "Hier",
      tomorrow: "Demain",
      favorites: "Favoris",
      addFavorite: "Ajouter aux favoris",
      removeFavorite: "Retirer des favoris",
      line: "Ligne",
      selection: "Sélection",
      middle: "Middle",
      middleWindow: "Fenêtre middle",
      corridor: "Couloir",
      legs: "Segments",
      pick: "Choix",
      picks: "Choix",
      copied: "Copié"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Arbitrage",
      value: "Paris de Valeur",
      notes: "Notes"
    },
    header: {
      logout: "Déconnexion",
      language: "Langue"
    },
    sports: {
      football: "Football",
      tennis: "Tennis",
      basketball: "Basket",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Suivez les mouvements rapides de cotes sur les marchés",
      highMove: "Fort Mouvement",
      steamStrength: "Force Steam",
      movePercent: "Mouvement %",
      openingOdds: "Cotes d'Ouverture",
      currentOdds: "Cotes Actuelles",
      directionUp: "Hausse",
      directionDown: "Baisse",
      directionFlat: "Stable",
      sharpSignal: "Signal Sharp",
      publicSignal: "Signal Public",
      confidence: "Confiance",
      marketType: "Type de Marché",
      overUnder: "Plus/Moins",
      handicap: "Handicap",
      moneyline: "Moneyline",
      noSteam: "Aucun steam move trouvé",
      tierYellow: "Jaune",
      tierOrange: "Orange",
      tierGreen: "Vert",
      chipBettingSplits: "Splits de paris",
      chipMovement: "Mouvement",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Jaune",
      signalLabelOrange: "Steam · Orange",
      signalLabelGreen: "Steam · Vert",
      reasonYellow: "Volume géré et part des paris divergent ; splits uniquement.",
      reasonOrange: "Splits plus mouvement confirmé des cotes.",
      reasonGreen: "Splits, mouvement, ligne EV Pinnacle et EV positif alignés.",
      splitsLabel: "Argent",
      betsLabel: "Paris",
      splitsGapLabel: "Écart",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Mouvement",
      bettingSplitsLabel: "Splits de paris",
      movementConfirmedLabel: "Mouvement confirmé",
      pinnacleConfirmedLabel: "Pinnacle confirmé",
      positiveEvLabel: "EV positif",
      previewLabel: "Aperçu",
      previewReasonYellow: "Exemple : splits uniquement (jaune).",
      previewReasonOrange: "Exemple : splits + mouvement (orange).",
      previewReasonGreen: "Exemple : alignement vert complet."
    },
    arbitrage: {
      title: "Arbitrage",
      subtitle: "Trouvez des opportunités sans risque",
      profitPercent: "Profit %",
      totalStake: "Mise Totale",
      guaranteedProfit: "Profit Garanti",
      stakeSplit: "Répartition de Mise",
      bestOdds: "Meilleures Cotes",
      opportunity: "Opportunité",
      noArb: "Aucune opportunité d'arbitrage trouvée",
      compareBookmakers: "Comparer les bookmakers",
      groupA: "Groupe A",
      groupB: "Groupe B",
      autoOn: "Auto ON",
      autoOff: "Auto OFF",
      autoOnShort: "Auto: ON",
      autoOffShort: "Auto: OFF",
      last: "Dernier",
      clearA: "Effacer A",
      clearB: "Effacer B",
      pause: "Pause",
      resume: "Reprendre",
      scan: "Scanner",
      scanning: "Scan en cours...",
      selectBookmakers: "Sélectionner des bookmakers...",
      swapGroups: "Échanger A ↔ B",
      disconnected: "Déconnecté",
      retainedData: "Données conservées",
      liveFeed: "Flux en direct",
      freshBatch: "À jour",
      apiDisconnected: "API indisponible",
      backendError: "Erreur serveur",
      fetchError: "Erreur réseau",
      noArbitrageInPool: "Aucun arbitrage dans le pool"
    },
    value: {
      title: "Paris de Valeur",
      subtitle: "Comparez le prix du marché avec la probabilité juste",
      valuePercent: "Valeur %",
      fairOdds: "Cotes Justes",
      edge: "Avantage",
      expectedValue: "Valeur Attendue",
      trueOdds: "Vraies Cotes",
      modelOdds: "Cotes du Modèle",
      recommendation: "Recommandation",
      strongValue: "Valeur Forte",
      mediumValue: "Valeur Moyenne",
      lowValue: "Valeur Faible",
      noValue: "Aucun pari de valeur trouvé"
    },
    stats: {
      title: "Notes",
      subtitle: "Suivi et aperçu des performances",
      totalBets: "Paris Totaux",
      winRate: "Taux de Réussite",
      averageOdds: "Cotes Moyennes",
      netProfit: "Profit Net",
      performance: "Performance",
      history: "Historique",
      recentActivity: "Activité Récente",
      emptyNotes: "Aucune note disponible"
    },
    marketTerms: {
      firstHalf: "1re mi-temps",
      secondHalf: "2e mi-temps",
      first10Min: "10 premières minutes",
      first15Min: "15 premières minutes",
      thirtyMinutes: "30 minutes",
      sixtyMinutes: "60 minutes",
      corners: "Corners",
      teamTotal: "Total équipe",
      exactGoals: "Nombre exact de buts",
      drawNoBet: "Match nul remboursé",
      doubleChance: "Double chance",
      winToNil: "Victoire sans encaisser",
      oddEven: "Impair / pair",
      handicapResult: "Résultat handicap",
      europeanHandicap: "Handicap européen",
      firstToScore: "Premier à marquer",
      scoreFirst: "Ouvre le score",
      scoreLast: "Marque en dernier",
      bothHalves: "Les deux mi-temps",
      eitherHalf: "Une mi-temps",
      totalGoalsAndBtts: "Total buts / les deux marquent",
      homeTeam: "Domicile",
      awayTeam: "Extérieur",
      raceTo: "Course à",
      goals: "Buts",
      cards: "Cartons",
      correctScore: "Score exact",
      winningMargin: "Marge de victoire",
      qualify: "Qualifier",
      trophy: "Trophée",
      outrightWinner: "Vainqueur outright",
      cleanSheet: "Clean sheet",
      firstGoalMethod: "Mode du 1er but",
      scoringDraw: "Match nul avec buts",
      goalLine: "Ligne de buts",
      teamCards: "Cartons équipe",
      teamCorners: "Corners équipe",
      totalCorners: "Total corners",
      totalCards: "Total cartons",
      bookingPoints: "Points cartons",
      penaltyAwarded: "Penalty accordé",
      shotsOnTarget: "Tirs cadrés",
      firstGoal: "Premier but",
      lastGoal: "Dernier but",
      homeCleanSheet: "Clean sheet domicile",
      awayCleanSheet: "Clean sheet extérieur",
      gameTotal: "Total du match"
    }
  },

  "de-DE": {
    common: {
      loading: "Wird geladen...",
      noData: "Keine Daten",
      all: "Alle",
      live: "Live",
      prematch: "Vor dem Spiel",
      search: "Suchen",
      filter: "Filter",
      refresh: "Aktualisieren",
      reset: "Zurücksetzen",
      apply: "Anwenden",
      save: "Speichern",
      close: "Schließen",
      clear: "Löschen",
      status: "Status",
      match: "Spiel",
      market: "Markt",
      league: "Liga",
      bookmaker: "Buchmacher",
      bookmakers: "Buchmacher",
      updated: "Aktualisiert",
      time: "Zeit",
      date: "Datum",
      home: "Heim",
      away: "Auswärts",
      score: "Ergebnis",
      odds: "Quoten",
      oddsLabel: "Quoten",
      trueOddsLabel: "Faire Quoten",
      stake: "Einsatz",
      profit: "Gewinn",
      payout: "Auszahlung",
      roi: "ROI",
      notes: "Notizen",
      today: "Heute",
      yesterday: "Gestern",
      tomorrow: "Morgen",
      favorites: "Favoriten",
      addFavorite: "Zu Favoriten hinzufügen",
      removeFavorite: "Aus Favoriten entfernen",
      line: "Linie",
      selection: "Auswahl",
      middle: "Middle",
      middleWindow: "Middle-Fenster",
      corridor: "Korridor",
      legs: "Teile",
      pick: "Tipp",
      picks: "Tipps",
      copied: "Kopiert"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Arbitrage",
      value: "Value Bets",
      notes: "Notizen"
    },
    header: {
      logout: "Abmelden",
      language: "Sprache"
    },
    sports: {
      football: "Fußball",
      tennis: "Tennis",
      basketball: "Basket",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Verfolge schnelle Quotenbewegungen über Märkte hinweg",
      highMove: "Starke Bewegung",
      steamStrength: "Steam-Stärke",
      movePercent: "Bewegung %",
      openingOdds: "Eröffnungsquoten",
      currentOdds: "Aktuelle Quoten",
      directionUp: "Aufwärts",
      directionDown: "Abwärts",
      directionFlat: "Stabil",
      sharpSignal: "Sharp-Signal",
      publicSignal: "Öffentliches Signal",
      confidence: "Vertrauen",
      marketType: "Markttyp",
      overUnder: "Über/Unter",
      handicap: "Handicap",
      moneyline: "Moneyline",
      noSteam: "Keine Steam Move gefunden",
      tierYellow: "Gelb",
      tierOrange: "Orange",
      tierGreen: "Grün",
      chipBettingSplits: "Wett-Splits",
      chipMovement: "Bewegung",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Gelb",
      signalLabelOrange: "Steam · Orange",
      signalLabelGreen: "Steam · Grün",
      reasonYellow: "Handle und Wettanteil weichen; nur Splits.",
      reasonOrange: "Splits plus bestätigte Quotenbewegung.",
      reasonGreen: "Splits, Bewegung, Pinnacle-EV-Zeile und positives EV stimmen überein.",
      splitsLabel: "Geld",
      betsLabel: "Wetten",
      splitsGapLabel: "Lücke",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Bewegung",
      bettingSplitsLabel: "Wett-Splits",
      movementConfirmedLabel: "Bewegung bestätigt",
      pinnacleConfirmedLabel: "Pinnacle bestätigt",
      positiveEvLabel: "Positives EV",
      previewLabel: "Vorschau",
      previewReasonYellow: "Beispiel: nur Splits (gelb).",
      previewReasonOrange: "Beispiel: Splits + Bewegung (orange).",
      previewReasonGreen: "Beispiel: volle grüne Übereinstimmung."
    },
    arbitrage: {
      title: "Arbitrage",
      subtitle: "Finde risikofreie Möglichkeiten",
      profitPercent: "Gewinn %",
      totalStake: "Gesamteinsatz",
      guaranteedProfit: "Garantierter Gewinn",
      stakeSplit: "Einsatzaufteilung",
      bestOdds: "Beste Quoten",
      opportunity: "Möglichkeit",
      noArb: "Keine Arbitrage-Möglichkeiten gefunden",
      compareBookmakers: "Bookmaker vergleichen",
      groupA: "Gruppe A",
      groupB: "Gruppe B",
      autoOn: "Auto ON",
      autoOff: "Auto OFF",
      autoOnShort: "Auto: ON",
      autoOffShort: "Auto: OFF",
      last: "Letzte",
      clearA: "A löschen",
      clearB: "B löschen",
      pause: "Pause",
      resume: "Fortsetzen",
      scan: "Scannen",
      scanning: "Scanne...",
      selectBookmakers: "Bookmaker auswählen...",
      swapGroups: "A ↔ B tauschen",
      disconnected: "Getrennt",
      retainedData: "Zwischengespeichert",
      liveFeed: "Live-Feed",
      freshBatch: "Frisch",
      apiDisconnected: "API getrennt",
      backendError: "Serverfehler",
      fetchError: "Abruffehler",
      noArbitrageInPool: "Keine Surebets im Pool"
    },
    value: {
      title: "Value Bets",
      subtitle: "Vergleiche Marktpreis mit fairer Wahrscheinlichkeit",
      valuePercent: "Wert %",
      fairOdds: "Faire Quoten",
      edge: "Vorteil",
      expectedValue: "Erwartungswert",
      trueOdds: "Wahre Quoten",
      modelOdds: "Modellquoten",
      recommendation: "Empfehlung",
      strongValue: "Starker Value",
      mediumValue: "Mittlerer Value",
      lowValue: "Niedriger Value",
      noValue: "Keine Value Bets gefunden"
    },
    stats: {
      title: "Notizen",
      subtitle: "Verfolgung und Leistungsübersicht",
      totalBets: "Gesamtwetten",
      winRate: "Gewinnrate",
      averageOdds: "Durchschnittsquoten",
      netProfit: "Nettogewinn",
      performance: "Leistung",
      history: "Verlauf",
      recentActivity: "Letzte Aktivität",
      emptyNotes: "Keine Notizen verfügbar"
    },
    marketTerms: {
      firstHalf: "1. Halbzeit",
      secondHalf: "2. Halbzeit",
      first10Min: "Erste 10 Minuten",
      first15Min: "Erste 15 Minuten",
      thirtyMinutes: "30 Minuten",
      sixtyMinutes: "60 Minuten",
      corners: "Ecken",
      teamTotal: "Team-Tore",
      exactGoals: "Exakte Toranzahl",
      drawNoBet: "Unentschieden gewinnt nicht",
      doubleChance: "Doppelte Chance",
      winToNil: "Sieg zu Null",
      oddEven: "Gerade / ungerade",
      handicapResult: "Handicap-Ergebnis",
      europeanHandicap: "Europäisches Handicap",
      firstToScore: "Erstes Tor",
      scoreFirst: "Erzielt zuerst",
      scoreLast: "Erzielt zuletzt",
      bothHalves: "Beide Halbzeiten",
      eitherHalf: "Eine Halbzeit",
      totalGoalsAndBtts: "Tore gesamt / beide treffen",
      homeTeam: "Heim",
      awayTeam: "Auswärts",
      raceTo: "Rennen bis",
      goals: "Tore",
      cards: "Karten",
      correctScore: "Korrektes Ergebnis",
      winningMargin: "Siegermarge",
      qualify: "Qualifizieren",
      trophy: "Pokal",
      outrightWinner: "Gesamtsieger",
      cleanSheet: "Zu Null",
      firstGoalMethod: "Art des 1. Tors",
      scoringDraw: "Torreiches Unentschieden",
      goalLine: "Torlinie",
      teamCards: "Team-Karten",
      teamCorners: "Team-Ecken",
      totalCorners: "Ecken gesamt",
      totalCards: "Karten gesamt",
      bookingPoints: "Booking Points",
      penaltyAwarded: "Elfmeter gegeben",
      shotsOnTarget: "Schüsse aufs Tor",
      firstGoal: "Erstes Tor",
      lastGoal: "Letztes Tor",
      homeCleanSheet: "Heim zu Null",
      awayCleanSheet: "Auswärts zu Null",
      gameTotal: "Spiel-Gesamt"
    }
  },

  "tr-TR": {
    common: {
      loading: "Yükleniyor...",
      noData: "Veri yok",
      all: "Tümü",
      live: "Canlı",
      prematch: "Maç Öncesi",
      search: "Ara",
      filter: "Filtre",
      refresh: "Yenile",
      reset: "Sıfırla",
      apply: "Uygula",
      save: "Kaydet",
      close: "Kapat",
      clear: "Temizle",
      status: "Durum",
      match: "Maç",
      market: "Pazar",
      league: "Lig",
      bookmaker: "Bahis Şirketi",
      bookmakers: "Bahis Şirketleri",
      updated: "Güncellendi",
      time: "Saat",
      date: "Tarih",
      home: "Ev Sahibi",
      away: "Deplasman",
      score: "Skor",
      odds: "Oranlar",
      oddsLabel: "Oranlar",
      trueOddsLabel: "Gerçek Oranlar",
      stake: "Bahis Tutarı",
      profit: "Kâr",
      payout: "Ödeme",
      roi: "ROI",
      notes: "Notlar",
      today: "Bugün",
      yesterday: "Dün",
      tomorrow: "Yarın",
      favorites: "Favoriler",
      addFavorite: "Favorilere ekle",
      removeFavorite: "Favorilerden çıkar",
      line: "Çizgi",
      selection: "Seçim",
      middle: "Middle",
      middleWindow: "Middle penceresi",
      corridor: "Koridor",
      legs: "Kuponlar",
      pick: "Seçim",
      picks: "Seçimler",
      copied: "Kopyalandı"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Arbitraj",
      value: "Değer Bahisleri",
      notes: "Notlar"
    },
    header: {
      logout: "Çıkış Yap",
      language: "Dil"
    },
    sports: {
      football: "Futbol",
      tennis: "Tenis",
      basketball: "Basket",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Piyasalardaki hızlı oran hareketlerini takip edin",
      highMove: "Yüksek Hareket",
      steamStrength: "Steam Gücü",
      movePercent: "Hareket %",
      openingOdds: "Açılış Oranları",
      currentOdds: "Güncel Oranlar",
      directionUp: "Yukarı",
      directionDown: "Aşağı",
      directionFlat: "Sabit",
      sharpSignal: "Sharp Sinyali",
      publicSignal: "Genel Sinyal",
      confidence: "Güven",
      marketType: "Pazar Türü",
      overUnder: "Alt/Üst",
      handicap: "Handikap",
      moneyline: "Moneyline",
      noSteam: "Steam move bulunamadı",
      tierYellow: "Sarı",
      tierOrange: "Turuncu",
      tierGreen: "Yeşil",
      chipBettingSplits: "Bahis splitleri",
      chipMovement: "Hareket",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Sarı",
      signalLabelOrange: "Steam · Turuncu",
      signalLabelGreen: "Steam · Yeşil",
      reasonYellow: "İşlem hacmi ve bahis payı ayrışıyor; yalnızca splitler.",
      reasonOrange: "Splitler artı onaylı oran hareketi.",
      reasonGreen: "Splitler, hareket, Pinnacle EV satırı ve pozitif EV uyumlu.",
      splitsLabel: "Para",
      betsLabel: "Bahisler",
      splitsGapLabel: "Fark",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Hareket",
      bettingSplitsLabel: "Bahis splitleri",
      movementConfirmedLabel: "Hareket onaylı",
      pinnacleConfirmedLabel: "Pinnacle onaylı",
      positiveEvLabel: "Pozitif EV",
      previewLabel: "Önizleme",
      previewReasonYellow: "Örnek: yalnızca splitler (sarı).",
      previewReasonOrange: "Örnek: splitler + hareket (turuncu).",
      previewReasonGreen: "Örnek: tam yeşil uyum."
    },
    arbitrage: {
      title: "Arbitraj",
      subtitle: "Risksiz fırsatları bulun",
      profitPercent: "Kâr %",
      totalStake: "Toplam Bahis",
      guaranteedProfit: "Garantili Kâr",
      stakeSplit: "Bahis Dağılımı",
      bestOdds: "En İyi Oranlar",
      opportunity: "Fırsat",
      noArb: "Arbitraj fırsatı bulunamadı",
      compareBookmakers: "Bookmaker karşılaştır",
      groupA: "Grup A",
      groupB: "Grup B",
      autoOn: "Oto ON",
      autoOff: "Oto OFF",
      autoOnShort: "Oto: ON",
      autoOffShort: "Oto: OFF",
      last: "Son",
      clearA: "A Temizle",
      clearB: "B Temizle",
      pause: "Duraklat",
      resume: "Sürdür",
      scan: "Tara",
      scanning: "Taranıyor...",
      selectBookmakers: "Bookmaker seç...",
      swapGroups: "A ↔ B Değiştir",
      disconnected: "Bağlantı yok",
      retainedData: "Önbellek verisi",
      liveFeed: "Canlı akış",
      freshBatch: "Yeni",
      apiDisconnected: "API bağlantısı yok",
      backendError: "Sunucu hatası",
      fetchError: "Yükleme hatası",
      noArbitrageInPool: "Havuzda arbitraj yok"
    },
    value: {
      title: "Değer Bahisleri",
      subtitle: "Piyasa fiyatını adil olasılıkla karşılaştırın",
      valuePercent: "Değer %",
      fairOdds: "Adil Oranlar",
      edge: "Avantaj",
      expectedValue: "Beklenen Değer",
      trueOdds: "Gerçek Oranlar",
      modelOdds: "Model Oranları",
      recommendation: "Öneri",
      strongValue: "Güçlü Değer",
      mediumValue: "Orta Değer",
      lowValue: "Düşük Değer",
      noValue: "Değer bahsi bulunamadı"
    },
    stats: {
      title: "Notlar",
      subtitle: "Takip ve performans özeti",
      totalBets: "Toplam Bahis",
      winRate: "Kazanma Oranı",
      averageOdds: "Ortalama Oranlar",
      netProfit: "Net Kâr",
      performance: "Performans",
      history: "Geçmiş",
      recentActivity: "Son Aktivite",
      emptyNotes: "Not yok"
    },
    marketTerms: {
      firstHalf: "İlk yarı",
      secondHalf: "İkinci yarı",
      first10Min: "İlk 10 dakika",
      first15Min: "İlk 15 dakika",
      thirtyMinutes: "30 dakika",
      sixtyMinutes: "60 dakika",
      corners: "Korner",
      teamTotal: "Takım toplamı",
      exactGoals: "Tam gol sayısı",
      drawNoBet: "Beraberlikte iade",
      doubleChance: "Çifte şans",
      winToNil: "Sıfıra kazanma",
      oddEven: "Tek / çift",
      handicapResult: "Handikap sonucu",
      europeanHandicap: "Avrupa handikapı",
      firstToScore: "İlk gol",
      scoreFirst: "İlk golü atan",
      scoreLast: "Son golü atan",
      bothHalves: "Her iki yarı",
      eitherHalf: "Herhangi bir yarı",
      totalGoalsAndBtts: "Toplam gol / KG var",
      homeTeam: "Ev sahibi",
      awayTeam: "Deplasman",
      raceTo: "Yarış",
      goals: "Gol",
      cards: "Kart",
      correctScore: "Doğru skor",
      winningMargin: "Galibiyet marjı",
      qualify: "Elemeler",
      trophy: "Kupa",
      outrightWinner: "Genel kazanan",
      cleanSheet: "Gol yemeden",
      firstGoalMethod: "İlk golün şekli",
      scoringDraw: "Gollü beraberlik",
      goalLine: "Gol çizgisi",
      teamCards: "Takım kartları",
      teamCorners: "Takım kornerleri",
      totalCorners: "Toplam korner",
      totalCards: "Toplam kart",
      bookingPoints: "Kart puanları",
      penaltyAwarded: "Penaltı verildi",
      shotsOnTarget: "İsabetli şut",
      firstGoal: "İlk gol",
      lastGoal: "Son gol",
      homeCleanSheet: "Ev gol yemeden",
      awayCleanSheet: "Deplasman gol yemeden",
      gameTotal: "Maç toplamı"
    }
  },

  "zh-CN": {
    common: {
      loading: "加载中...",
      noData: "暂无数据",
      all: "全部",
      live: "滚球",
      prematch: "赛前",
      search: "搜索",
      filter: "筛选",
      refresh: "刷新",
      reset: "重置",
      apply: "应用",
      save: "保存",
      close: "关闭",
      clear: "清除",
      status: "状态",
      match: "比赛",
      market: "盘口",
      league: "联赛",
      bookmaker: "博彩公司",
      bookmakers: "博彩公司",
      updated: "已更新",
      time: "时间",
      date: "日期",
      home: "主队",
      away: "客队",
      score: "比分",
      odds: "赔率",
      oddsLabel: "赔率",
      trueOddsLabel: "真实赔率",
      stake: "投注额",
      profit: "利润",
      payout: "返还",
      roi: "ROI",
      notes: "备注",
      today: "今天",
      yesterday: "昨天",
      tomorrow: "明天",
      favorites: "收藏",
      addFavorite: "添加收藏",
      removeFavorite: "取消收藏",
      line: "盘口",
      selection: "选项",
      middle: "中间",
      middleWindow: "中间区间",
      corridor: "走廊",
      legs: "分支",
      pick: "选项",
      picks: "选项",
      copied: "已复制"
    },
    tabs: {
      steam: "赔率异动",
      arb: "套利",
      value: "价值投注",
      notes: "备注"
    },
    header: {
      logout: "退出登录",
      language: "语言"
    },
    sports: {
      football: "足球",
      tennis: "网球",
      basketball: "篮球",
      esports: "电竞"
    },
    steam: {
      title: "赔率异动",
      subtitle: "追踪各市场中的快速赔率变化",
      highMove: "高波动",
      steamStrength: "异动强度",
      movePercent: "变化 %",
      openingOdds: "初始赔率",
      currentOdds: "当前赔率",
      directionUp: "上涨",
      directionDown: "下跌",
      directionFlat: "持平",
      sharpSignal: "专业信号",
      publicSignal: "大众信号",
      confidence: "置信度",
      marketType: "盘口类型",
      overUnder: "大小球",
      handicap: "让球",
      moneyline: "独赢",
      noSteam: "未找到赔率异动",
      tierYellow: "黄",
      tierOrange: "橙",
      tierGreen: "绿",
      chipBettingSplits: "投注分布",
      chipMovement: "走势",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · 黄",
      signalLabelOrange: "Steam · 橙",
      signalLabelGreen: "Steam · 绿",
      reasonYellow: "成交量与投注占比分化；仅分布信号。",
      reasonOrange: "分布加上已确认的赔率变动。",
      reasonGreen: "分布、走势、Pinnacle 确认 EV 与正 EV 一致。",
      splitsLabel: "资金",
      betsLabel: "笔数",
      splitsGapLabel: "差距",
      sharpDevigLabel: "Sharp / 去水",
      evLabel: "EV",
      movementLabel: "走势",
      bettingSplitsLabel: "投注分布",
      movementConfirmedLabel: "走势已确认",
      pinnacleConfirmedLabel: "Pinnacle 已确认",
      positiveEvLabel: "正 EV",
      previewLabel: "预览",
      previewReasonYellow: "示例：仅分布（黄）。",
      previewReasonOrange: "示例：分布+走势（橙）。",
      previewReasonGreen: "示例：完整绿档对齐。"
    },
    arbitrage: {
      title: "套利",
      subtitle: "寻找无风险机会",
      profitPercent: "利润 %",
      totalStake: "总投注额",
      guaranteedProfit: "保证利润",
      stakeSplit: "投注分配",
      bestOdds: "最佳赔率",
      opportunity: "机会",
      noArb: "未找到套利机会",
      compareBookmakers: "比较博彩公司",
      groupA: "A 组",
      groupB: "B 组",
      autoOn: "自动 ON",
      autoOff: "自动 OFF",
      autoOnShort: "自动: ON",
      autoOffShort: "自动: OFF",
      last: "最后",
      clearA: "清除 A",
      clearB: "清除 B",
      pause: "暂停",
      resume: "继续",
      scan: "扫描",
      scanning: "扫描中...",
      selectBookmakers: "选择博彩公司...",
      swapGroups: "交换 A ↔ B",
      disconnected: "已断开",
      retainedData: "缓存数据",
      liveFeed: "实时推送",
      freshBatch: "最新",
      apiDisconnected: "API 断开",
      backendError: "后端错误",
      fetchError: "获取失败",
      noArbitrageInPool: "池中无套利"
    },
    value: {
      title: "价值投注",
      subtitle: "比较市场价格与合理概率",
      valuePercent: "价值 %",
      fairOdds: "合理赔率",
      edge: "优势",
      expectedValue: "期望值",
      trueOdds: "真实赔率",
      modelOdds: "模型赔率",
      recommendation: "建议",
      strongValue: "高价值",
      mediumValue: "中等价值",
      lowValue: "低价值",
      noValue: "未找到价值投注"
    },
    stats: {
      title: "备注",
      subtitle: "跟踪与表现概览",
      totalBets: "总投注数",
      winRate: "胜率",
      averageOdds: "平均赔率",
      netProfit: "净利润",
      performance: "表现",
      history: "历史",
      recentActivity: "最近活动",
      emptyNotes: "暂无备注"
    },
    marketTerms: {
      firstHalf: "上半场",
      secondHalf: "下半场",
      first10Min: "前10分钟",
      first15Min: "前15分钟",
      thirtyMinutes: "30分钟",
      sixtyMinutes: "60分钟",
      corners: "角球",
      teamTotal: "球队进球",
      exactGoals: "精确进球数",
      drawNoBet: "不让球胜平负",
      doubleChance: "双重机会",
      winToNil: "零封胜",
      oddEven: "单 / 双",
      handicapResult: "让球赛果",
      europeanHandicap: "欧盘让球",
      firstToScore: "先进球",
      scoreFirst: "先进球",
      scoreLast: "最后进球",
      bothHalves: "双半场",
      eitherHalf: "任一半场",
      totalGoalsAndBtts: "总进球 / 双方进球",
      homeTeam: "主队",
      awayTeam: "客队",
      raceTo: "抢先",
      goals: "进球",
      cards: "牌",
      correctScore: "波胆",
      winningMargin: "净胜",
      qualify: "晋级",
      trophy: "奖杯",
      outrightWinner: "全程冠军",
      cleanSheet: "零封",
      firstGoalMethod: "首个进球方式",
      scoringDraw: "有进球平局",
      goalLine: "进球线",
      teamCards: "球队牌数",
      teamCorners: "球队角球",
      totalCorners: "角球总数",
      totalCards: "总牌数",
      bookingPoints: "牌分",
      penaltyAwarded: "判罚点球",
      shotsOnTarget: "射正",
      firstGoal: "首球",
      lastGoal: "末球",
      homeCleanSheet: "主队零封",
      awayCleanSheet: "客队零封",
      gameTotal: "全场总分"
    }
  },

  "th-TH": {
    common: {
      loading: "กำลังโหลด...",
      noData: "ไม่มีข้อมูล",
      all: "ทั้งหมด",
      live: "สด",
      prematch: "ก่อนแข่ง",
      search: "ค้นหา",
      filter: "ตัวกรอง",
      refresh: "รีเฟรช",
      reset: "รีเซ็ต",
      apply: "นำไปใช้",
      save: "บันทึก",
      close: "ปิด",
      clear: "ล้าง",
      status: "สถานะ",
      match: "การแข่งขัน",
      market: "ตลาด",
      league: "ลีก",
      bookmaker: "เจ้ามือ",
      bookmakers: "เจ้ามือ",
      updated: "อัปเดตแล้ว",
      time: "เวลา",
      date: "วันที่",
      home: "เจ้าบ้าน",
      away: "ทีมเยือน",
      score: "สกอร์",
      odds: "อัตราต่อรอง",
      oddsLabel: "อัตราต่อรอง",
      trueOddsLabel: "ราคาต่อรองจริง",
      stake: "เงินเดิมพัน",
      profit: "กำไร",
      payout: "จ่ายคืน",
      roi: "ROI",
      notes: "บันทึก",
      today: "วันนี้",
      yesterday: "เมื่อวาน",
      tomorrow: "พรุ่งนี้",
      favorites: "รายการโปรด",
      addFavorite: "เพิ่มในรายการโปรด",
      removeFavorite: "ลบออกจากรายการโปรด",
      line: "เส้น",
      selection: "ตัวเลือก",
      middle: "มิดเดิล",
      middleWindow: "ช่วงมิดเดิล",
      corridor: "ทางเดิน",
      legs: "ฝั่งเดิมพัน",
      pick: "เลือก",
      picks: "ตัวเลือก",
      copied: "คัดลอกแล้ว"
    },
    tabs: {
      steam: "Steam Move",
      arb: "อาร์บิทราจ",
      value: "เดิมพันมูลค่า",
      notes: "บันทึก"
    },
    header: {
      logout: "ออกจากระบบ",
      language: "ภาษา"
    },
    sports: {
      football: "ฟุตบอล",
      tennis: "เทนนิส",
      basketball: "บาส",
      esports: "อีสปอร์ต"
    },
    steam: {
      title: "Steam Move",
      subtitle: "ติดตามการเปลี่ยนแปลงราคาต่อรองอย่างรวดเร็วในตลาด",
      highMove: "การเคลื่อนไหวสูง",
      steamStrength: "ความแรงของ Steam",
      movePercent: "การเปลี่ยนแปลง %",
      openingOdds: "ราคาต่อรองเปิด",
      currentOdds: "ราคาต่อรองปัจจุบัน",
      directionUp: "ขึ้น",
      directionDown: "ลง",
      directionFlat: "คงที่",
      sharpSignal: "สัญญาณ Sharp",
      publicSignal: "สัญญาณสาธารณะ",
      confidence: "ความมั่นใจ",
      marketType: "ประเภทตลาด",
      overUnder: "สูง/ต่ำ",
      handicap: "แฮนดิแคป",
      moneyline: "มันนี่ไลน์",
      noSteam: "ไม่พบ Steam Move",
      tierYellow: "เหลือง",
      tierOrange: "ส้ม",
      tierGreen: "เขียว",
      chipBettingSplits: "สปลิตเดิมพัน",
      chipMovement: "การเคลื่อนไหว",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · เหลือง",
      signalLabelOrange: "Steam · ส้ม",
      signalLabelGreen: "Steam · เขียว",
      reasonYellow: "ปริมาณกับสัดส่วนเดิมพันแตกต่าง; ระดับสปลิตอย่างเดียว",
      reasonOrange: "สปลิตบวกการเคลื่อนไหวของราคาที่ยืนยันแล้ว",
      reasonGreen: "สปลิต การเคลื่อนไหว แถว EV จาก Pinnacle และ EV บวกสอดคล้องกัน",
      splitsLabel: "เงิน",
      betsLabel: "จำนวนเดิมพัน",
      splitsGapLabel: "ช่องว่าง",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "การเคลื่อนไหว",
      bettingSplitsLabel: "สปลิตเดิมพัน",
      movementConfirmedLabel: "ยืนยันการเคลื่อนไหวแล้ว",
      pinnacleConfirmedLabel: "ยืนยัน Pinnacle แล้ว",
      positiveEvLabel: "EV บวก",
      previewLabel: "ตัวอย่าง",
      previewReasonYellow: "ตัวอย่าง: สปลิตอย่างเดียว (เหลือง)",
      previewReasonOrange: "ตัวอย่าง: สปลิต + การเคลื่อนไหว (ส้ม)",
      previewReasonGreen: "ตัวอย่าง: เขียวครบถ้วน"
    },
    arbitrage: {
      title: "อาร์บิทราจ",
      subtitle: "ค้นหาโอกาสที่ไม่มีความเสี่ยง",
      profitPercent: "กำไร %",
      totalStake: "ยอดเดิมพันรวม",
      guaranteedProfit: "กำไรที่รับประกัน",
      stakeSplit: "การแบ่งเงินเดิมพัน",
      bestOdds: "ราคาต่อรองที่ดีที่สุด",
      opportunity: "โอกาส",
      noArb: "ไม่พบโอกาสอาร์บิทราจ",
      compareBookmakers: "เปรียบเทียบเจ้ามือ",
      groupA: "กลุ่ม A",
      groupB: "กลุ่ม B",
      autoOn: "ออโต้ ON",
      autoOff: "ออโต้ OFF",
      autoOnShort: "ออโต้: ON",
      autoOffShort: "ออโต้: OFF",
      last: "ล่าสุด",
      clearA: "ล้าง A",
      clearB: "ล้าง B",
      pause: "หยุด",
      resume: "ต่อ",
      scan: "สแกน",
      scanning: "กำลังสแกน...",
      selectBookmakers: "เลือกเจ้ามือ...",
      swapGroups: "สลับ A ↔ B",
      disconnected: "ขาดการเชื่อมต่อ",
      retainedData: "ข้อมูลที่เก็บไว้",
      liveFeed: "ฟีดสด",
      freshBatch: "ล่าสุด",
      apiDisconnected: "API ตัดการเชื่อมต่อ",
      backendError: "ข้อผิดพลาดเซิร์ฟเวอร์",
      fetchError: "โหลดไม่สำเร็จ",
      noArbitrageInPool: "ไม่มีอาร์บในพูล"
    },
    value: {
      title: "เดิมพันมูลค่า",
      subtitle: "เปรียบเทียบราคาตลาดกับความน่าจะเป็นที่ยุติธรรม",
      valuePercent: "มูลค่า %",
      fairOdds: "ราคาต่อรองที่ยุติธรรม",
      edge: "ความได้เปรียบ",
      expectedValue: "มูลค่าคาดหวัง",
      trueOdds: "ราคาต่อรองที่แท้จริง",
      modelOdds: "ราคาต่อรองโมเดล",
      recommendation: "คำแนะนำ",
      strongValue: "มูลค่าสูง",
      mediumValue: "มูลค่าปานกลาง",
      lowValue: "มูลค่าต่ำ",
      noValue: "ไม่พบเดิมพันมูลค่า"
    },
    stats: {
      title: "บันทึก",
      subtitle: "การติดตามและภาพรวมประสิทธิภาพ",
      totalBets: "จำนวนเดิมพันทั้งหมด",
      winRate: "อัตราชนะ",
      averageOdds: "ราคาต่อรองเฉลี่ย",
      netProfit: "กำไรสุทธิ",
      performance: "ประสิทธิภาพ",
      history: "ประวัติ",
      recentActivity: "กิจกรรมล่าสุด",
      emptyNotes: "ไม่มีบันทึก"
    },
    marketTerms: {
      firstHalf: "ครึ่งแรก",
      secondHalf: "ครึ่งหลัง",
      first10Min: "10 นาทีแรก",
      first15Min: "15 นาทีแรก",
      thirtyMinutes: "30 นาที",
      sixtyMinutes: "60 นาที",
      corners: "เตะมุม",
      teamTotal: "ทีมสกอร์รวม",
      exactGoals: "จำนวนประตูตรง",
      drawNoBet: "เสมอคืนเงิน",
      doubleChance: "โอกาสคู่",
      winToNil: "ชนะคลีนชีต",
      oddEven: "คี่ / คู่",
      handicapResult: "ผลแฮนดิแคป",
      europeanHandicap: "แฮนดิแคปยุโรป",
      firstToScore: "ยิงก่อน",
      scoreFirst: "ยิงก่อน",
      scoreLast: "ยิงท้าย",
      bothHalves: "ทั้งสองครึ่ง",
      eitherHalf: "ครึ่งใดครึ่งหนึ่ง",
      totalGoalsAndBtts: "สกอร์รวม / ทั้งคู่ยิง",
      homeTeam: "เจ้าบ้าน",
      awayTeam: "ทีมเยือน",
      raceTo: "แข่งถึง",
      goals: "ประตู",
      cards: "ใบ",
      correctScore: "สกอร์ตรง",
      winningMargin: "ต่างประตูชนะ",
      qualify: "ผ่านเข้ารอบ",
      trophy: "ถ้วย",
      outrightWinner: "แชมป์รวม",
      cleanSheet: "คลีนชีต",
      firstGoalMethod: "วิธีประตูแรก",
      scoringDraw: "เสมอมีสกอร์",
      goalLine: "เส้นสกอร์",
      teamCards: "ใบทีม",
      teamCorners: "เตะมุมทีม",
      totalCorners: "เตะมุมรวม",
      totalCards: "ใบรวม",
      bookingPoints: "คะแนนใบ",
      penaltyAwarded: "ได้จุดโทษ",
      shotsOnTarget: "ยิงตรงกรอบ",
      firstGoal: "ประตูแรก",
      lastGoal: "ประตูสุดท้าย",
      homeCleanSheet: "เจ้าบ้านคลีนชีต",
      awayCleanSheet: "ทีมเยือนคลีนชีต",
      gameTotal: "สกอร์รวมเกม"
    }
  },

  "vi-VN": {
    common: {
      loading: "Đang tải...",
      noData: "Không có dữ liệu",
      all: "Tất cả",
      live: "Live",
      prematch: "Sớm",
      search: "Tìm kiếm",
      filter: "Bộ lọc",
      refresh: "Làm mới",
      reset: "Đặt lại",
      apply: "Áp dụng",
      save: "Lưu",
      close: "Đóng",
      clear: "Xóa",
      status: "Trạng thái",
      match: "Trận đấu",
      market: "Loại kèo",
      league: "Giải đấu",
      bookmaker: "Nhà cái",
      bookmakers: "Nhà cái",
      updated: "Cập nhật",
      time: "Giờ",
      date: "Ngày",
      home: "Chủ nhà",
      away: "Đội khách",
      score: "Tỷ số",
      odds: "Tỷ lệ cược",
      oddsLabel: "Tỷ lệ cược",
      trueOddsLabel: "Tỷ lệ thực",
      stake: "Tiền cược",
      profit: "Lợi nhuận",
      payout: "Thanh toán",
      roi: "ROI",
      notes: "Ghi chú",
      today: "Hôm nay",
      yesterday: "Hôm qua",
      tomorrow: "Ngày mai",
      favorites: "Yêu thích",
      addFavorite: "Thêm vào yêu thích",
      removeFavorite: "Gỡ khỏi yêu thích",
      line: "Mốc kèo",
      selection: "Cửa cược",
      middle: "Cửa giữa",
      middleWindow: "Biên giữa",
      corridor: "Hành lang",
      legs: "Hai đầu cược",
      pick: "Cửa cược",
      picks: "Cửa cược",
      copied: "Đã sao chép"
    },
    tabs: {
      steam: "Biến Động",
      value: "Giá Trị",
      arb: "Chênh Giá",
      middles: "Kèo Giữa",
      notes: "Tuỳ Chọn"
    },
    header: {
      logout: "Thoát",
      language: "Ngôn ngữ"
    },
    sports: {
      football: "Bóng đá",
      tennis: "Tennis",
      basketball: "Bóng rổ",
      esports: "Esports"
    },
    steam: {
      title: "Biến động kèo",
      subtitle: "Theo dõi biến động tỷ lệ nhanh trên các kèo",
      highMove: "Biến động cao",
      steamStrength: "Độ mạnh steam",
      movePercent: "Mức biến động %",
      openingOdds: "Tỷ lệ mở",
      currentOdds: "Tỷ lệ hiện tại",
      directionUp: "Tăng",
      directionDown: "Giảm",
      directionFlat: "Đi ngang",
      sharpSignal: "Tín hiệu sharp",
      publicSignal: "Tín hiệu public",
      confidence: "Độ tin cậy",
      marketType: "Loại kèo",
      overUnder: "Tài/Xỉu",
      handicap: "Kèo chấp",
      moneyline: "Kèo thắng",
      noSteam: "Không có biến động kèo",
      tierYellow: "Vàng",
      tierOrange: "Cam",
      tierGreen: "Xanh lá",
      chipBettingSplits: "Phân bổ cược",
      chipMovement: "Biến động kèo",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Vàng",
      signalLabelOrange: "Steam · Cam",
      signalLabelGreen: "Steam · Xanh lá",
      reasonYellow: "Khối lượng và tỷ lệ cược vé lệch nhau; chỉ tín hiệu phân bổ.",
      reasonOrange: "Phân bổ cộng biến động tỷ lệ đã xác nhận.",
      reasonGreen: "Phân bổ, biến động, dòng EV Pinnacle và EV dương khớp nhau.",
      splitsLabel: "Tiền",
      betsLabel: "Vé cược",
      splitsGapLabel: "Chênh lệch",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Biến động",
      bettingSplitsLabel: "Phân bổ cược",
      movementConfirmedLabel: "Đã xác nhận biến động",
      pinnacleConfirmedLabel: "Đã xác nhận Pinnacle",
      positiveEvLabel: "EV dương",
      previewLabel: "Xem trước",
      previewReasonYellow: "Ví dụ: chỉ phân bổ (vàng).",
      previewReasonOrange: "Ví dụ: phân bổ + biến động (cam).",
      previewReasonGreen: "Ví dụ: đủ điều kiện xanh.",
      previewLeagueSplits: "Preview League — Splits",
      previewLeagueMove: "Preview League — Move",
      previewLeagueEv: "Preview League — EV",
      previewMatchSplits: "Mock United vs Preview City",
      previewMatchMove: "Line Move FC vs Steam Town",
      previewMatchEv: "Sharp Side vs Devig Athletic",
      previewBookA: "BetPreview",
      previewBookB: "MoveLine",
      previewBookC: "ConfirmBook",
      previewSplitsBookConsensus: "Consensus",
      previewSplitsBookMarket: "Market"
    },
    middles: {
      previewWindowThreeGoals: "3 bàn",
      previewCorridorOnePt: "Hành lang 1.0 điểm",
      previewWindowRounds2122: "21–22 vòng",
      guaranteedProfit: "Lợi nhuận đảm bảo",
      guaranteedBadge: "Đảm bảo",
      keyNumbers: "Số then chốt",
      largeGap: "Khoảng giữa lớn",
      staleOdds: "Odds cũ",
      highProbability: "Xác suất cao",
      liveGame: "Đang live",
      middleProbabilityLabel: "Xác suất trúng",
      roiLabel: "Lợi nhuận kỳ vọng",
      worstCase: "Tệ nhất",
      bestCase: "Tốt nhất",
      breakEven: "Hoà vốn",
      middleSize: "Khoảng giữa",
      middleWindow: "Vùng thắng"
    },
    arbitrage: {
      title: "Arbitrage",
      subtitle: "Tìm cơ hội chênh kèo an toàn",
      profitPercent: "Lợi nhuận %",
      totalStake: "Tổng vốn",
      guaranteedProfit: "Lợi nhuận đảm bảo",
      stakeSplit: "Chia vốn",
      bestOdds: "Tỷ lệ cược tốt nhất",
      opportunity: "Cơ hội",
      noArb: "Không tìm thấy cơ hội chênh kèo",
      compareBookmakers: "So sánh nhà cái",
      groupA: "Nhóm A",
      groupB: "Nhóm B",
      autoOn: "Tự động ON",
      autoOff: "Tự động OFF",
      autoOnShort: "Tự động: ON",
      autoOffShort: "Tự động: OFF",
      last: "Lần cuối",
      clearA: "Xóa A",
      clearB: "Xóa B",
      pause: "Tạm dừng",
      resume: "Tiếp tục",
      scan: "Quét",
      scanning: "Đang quét...",
      selectBookmakers: "Chọn nhà cái...",
      swapGroups: "Đổi A ↔ B",
      disconnected: "Mất kết nối",
      retainedData: "Dữ liệu giữ lại",
      liveFeed: "Luồng trực tiếp",
      freshBatch: "Mới cập nhật",
      apiDisconnected: "API mất kết nối",
      backendError: "Lỗi backend",
      fetchError: "Lỗi tải dữ liệu",
      noArbitrageInPool: "Không có cơ hội arbitrage trong danh sách",
      revisionShort: "bản"
    },
    value: {
      title: "Kèo giá trị",
      subtitle: "So sánh giá kèo với xác suất hợp lý",
      valuePercent: "Giá trị %",
      fairOdds: "Tỷ lệ thực",
      edge: "Lợi thế",
      expectedValue: "EV kỳ vọng",
      trueOdds: "Tỷ lệ thực",
      modelOdds: "Tỷ lệ mô hình",
      recommendation: "Khuyến nghị",
      strongValue: "Giá trị cao",
      mediumValue: "Giá trị vừa",
      lowValue: "Giá trị thấp",
      noValue: "Không tìm thấy kèo giá trị"
    },
    stats: {
      title: "Tuỳ Chọn",
      subtitle: "Công cụ tính nhanh và cài đặt hiển thị",
      totalBets: "Tổng cược",
      winRate: "Tỷ lệ thắng",
      averageOdds: "Tỷ lệ trung bình",
      netProfit: "Lợi nhuận ròng",
      performance: "Hiệu suất",
      history: "Lịch sử",
      recentActivity: "Hoạt động gần đây",
      emptyNotes: "Chưa có ghi chú"
    },
    marketTerms: {
      firstHalf: "Hiệp 1",
      secondHalf: "Hiệp 2",
      first10Min: "10 phút đầu",
      first15Min: "15 phút đầu",
      thirtyMinutes: "30 phút",
      sixtyMinutes: "60 phút",
      corners: "Phạt góc",
      teamTotal: "Tổng đội",
      exactGoals: "Số Bàn Chính Xác",
      drawNoBet: "Hòa hoàn tiền",
      doubleChance: "Cơ hội kép",
      winToNil: "Thắng trắng",
      oddEven: "Lẻ / chẵn",
      handicapResult: "Kết quả kèo chấp",
      europeanHandicap: "Kèo chấp châu Âu",
      firstToScore: "Ghi bàn trước",
      scoreFirst: "Ghi trước",
      scoreLast: "Ghi sau",
      bothHalves: "Cả hai hiệp",
      eitherHalf: "Một trong hai hiệp",
      totalGoalsAndBtts: "Tổng bàn thắng / cả hai đội ghi bàn",
      homeTeam: "Chủ nhà",
      awayTeam: "Đội khách",
      raceTo: "Đua tới",
      goals: "Bàn thắng",
      cards: "Thẻ phạt",
      correctScore: "Tỷ số chính xác",
      winningMargin: "Cách biệt thắng",
      qualify: "Đội đi tiếp",
      trophy: "Danh hiệu",
      outrightWinner: "Vô địch chung cuộc",
      cleanSheet: "Giữ sạch lưới",
      firstGoalMethod: "Cách ghi bàn mở tỷ số",
      scoringDraw: "Hòa có bàn",
      goalLine: "Mốc bàn thắng",
      teamCards: "Thẻ đội",
      teamCorners: "Phạt góc đội",
      totalCorners: "Tổng phạt góc",
      totalCards: "Tổng thẻ",
      bookingPoints: "Điểm thẻ",
      penaltyAwarded: "Được hưởng phạt đền",
      shotsOnTarget: "Cú sút trúng đích",
      firstGoal: "Bàn mở tỷ số",
      lastGoal: "Bàn cuối",
      homeCleanSheet: "Chủ nhà giữ sạch lưới",
      awayCleanSheet: "Đội khách giữ sạch lưới",
      gameTotal: "Tổng trận"
    },
    periodScopes: {
      fullTime: "FT",
      firstHalf: "Hiệp 1",
      secondHalf: "Hiệp 2",
      firstQuarter: "Q1",
      secondQuarter: "Q2",
      firstSet: "Set 1",
      secondSet: "Set 2",
      first10Min: "10 phút đầu",
      first15Min: "15 phút đầu",
      thirtyMinutes: "30 Phút",
      sixtyMinutes: "60 Phút"
    }
  },

  "ko-KR": {
    common: {
      loading: "로딩 중...",
      noData: "데이터 없음",
      all: "전체",
      live: "라이브",
      prematch: "경기 전",
      search: "검색",
      filter: "필터",
      refresh: "새로고침",
      reset: "초기화",
      apply: "적용",
      save: "저장",
      close: "닫기",
      clear: "지우기",
      status: "상태",
      match: "경기",
      market: "마켓",
      league: "리그",
      bookmaker: "북메이커",
      bookmakers: "북메이커",
      updated: "업데이트됨",
      time: "시간",
      date: "날짜",
      home: "홈",
      away: "원정",
      score: "점수",
      odds: "배당",
      oddsLabel: "배당",
      trueOddsLabel: "실제 배당",
      stake: "베팅 금액",
      profit: "수익",
      payout: "지급액",
      roi: "ROI",
      notes: "메모",
      today: "오늘",
      yesterday: "어제",
      tomorrow: "내일",
      favorites: "즐겨찾기",
      addFavorite: "즐겨찾기에 추가",
      removeFavorite: "즐겨찾기에서 제거",
      line: "라인",
      selection: "선택",
      middle: "미들",
      middleWindow: "미들 구간",
      corridor: "코리더",
      legs: "레그",
      pick: "픽",
      picks: "픽",
      copied: "복사됨"
    },
    tabs: {
      steam: "스팀 무브",
      arb: "아비트라지",
      value: "가치 베팅",
      notes: "메모"
    },
    header: {
      logout: "로그아웃",
      language: "언어"
    },
    sports: {
      football: "축구",
      tennis: "테니스",
      basketball: "농구",
      esports: "e스포츠"
    },
    steam: {
      title: "스팀 무브",
      subtitle: "시장 전반의 빠른 배당 변화를 추적",
      highMove: "높은 변동",
      steamStrength: "스팀 강도",
      movePercent: "변동 %",
      openingOdds: "시작 배당",
      currentOdds: "현재 배당",
      directionUp: "상승",
      directionDown: "하락",
      directionFlat: "변동 없음",
      sharpSignal: "샤프 신호",
      publicSignal: "대중 신호",
      confidence: "신뢰도",
      marketType: "마켓 유형",
      overUnder: "오버/언더",
      handicap: "핸디캡",
      moneyline: "머니라인",
      noSteam: "스팀 무브를 찾을 수 없습니다",
      tierYellow: "옐로우",
      tierOrange: "오렌지",
      tierGreen: "그린",
      chipBettingSplits: "베팅 스플릿",
      chipMovement: "움직임",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "스팀 · 옐로우",
      signalLabelOrange: "스팀 · 오렌지",
      signalLabelGreen: "스팀 · 그린",
      reasonYellow: "핸들과 베팅 비중이 갈림; 스플릿만 해당.",
      reasonOrange: "스플릿과 확인된 배당 움직임.",
      reasonGreen: "스플릿, 움직임, Pinnacle EV 행, 양의 EV가 일치.",
      splitsLabel: "머니",
      betsLabel: "베팅 수",
      splitsGapLabel: "갭",
      sharpDevigLabel: "샤프 / 디비그",
      evLabel: "EV",
      movementLabel: "움직임",
      bettingSplitsLabel: "베팅 스플릿",
      movementConfirmedLabel: "움직임 확인됨",
      pinnacleConfirmedLabel: "Pinnacle 확인됨",
      positiveEvLabel: "양의 EV",
      previewLabel: "미리보기",
      previewReasonYellow: "예: 스플릿만 (옐로우).",
      previewReasonOrange: "예: 스플릿+움직임 (오렌지).",
      previewReasonGreen: "예: 풀 그린 일치."
    },
    arbitrage: {
      title: "아비트라지",
      subtitle: "무위험 기회를 찾으세요",
      profitPercent: "수익 %",
      totalStake: "총 베팅 금액",
      guaranteedProfit: "보장 수익",
      stakeSplit: "베팅 분배",
      bestOdds: "최고 배당",
      opportunity: "기회",
      noArb: "아비트라지 기회를 찾을 수 없습니다",
      compareBookmakers: "북메이커 비교",
      groupA: "그룹 A",
      groupB: "그룹 B",
      autoOn: "자동 ON",
      autoOff: "자동 OFF",
      autoOnShort: "자동: ON",
      autoOffShort: "자동: OFF",
      last: "마지막",
      clearA: "A 지우기",
      clearB: "B 지우기",
      pause: "일시정지",
      resume: "재개",
      scan: "스캔",
      scanning: "스캔 중...",
      selectBookmakers: "북메이커 선택...",
      swapGroups: "A ↔ B 교체",
      disconnected: "연결 끊김",
      retainedData: "유지된 데이터",
      liveFeed: "라이브 피드",
      freshBatch: "최신",
      apiDisconnected: "API 연결 안 됨",
      backendError: "서버 오류",
      fetchError: "불러오기 오류",
      noArbitrageInPool: "풀에 차익이 없음"
    },
    value: {
      title: "가치 베팅",
      subtitle: "시장 가격과 공정 확률을 비교",
      valuePercent: "가치 %",
      fairOdds: "공정 배당",
      edge: "우위",
      expectedValue: "기대값",
      trueOdds: "실제 배당",
      modelOdds: "모델 배당",
      recommendation: "추천",
      strongValue: "높은 가치",
      mediumValue: "중간 가치",
      lowValue: "낮은 가치",
      noValue: "가치 베팅을 찾을 수 없습니다"
    },
    stats: {
      title: "메모",
      subtitle: "추적 및 성과 개요",
      totalBets: "총 베팅 수",
      winRate: "승률",
      averageOdds: "평균 배당",
      netProfit: "순이익",
      performance: "성과",
      history: "기록",
      recentActivity: "최근 활동",
      emptyNotes: "메모가 없습니다"
    },
    marketTerms: {
      firstHalf: "전반",
      secondHalf: "후반",
      first10Min: "전반 10분",
      first15Min: "전반 15분",
      thirtyMinutes: "30분",
      sixtyMinutes: "60분",
      corners: "코너킥",
      teamTotal: "팀 총득점",
      exactGoals: "정확한 득점 수",
      drawNoBet: "무승부 제외",
      doubleChance: "더블찬스",
      winToNil: "클린시트 승리",
      oddEven: "홀 / 짝",
      handicapResult: "핸디 결과",
      europeanHandicap: "유럽형 핸디캡",
      firstToScore: "선제골",
      scoreFirst: "먼저 득점",
      scoreLast: "마지막 득점",
      bothHalves: "양쪽 하프",
      eitherHalf: "한 하프",
      totalGoalsAndBtts: "총골 / 양팀 득점",
      homeTeam: "홈",
      awayTeam: "원정",
      raceTo: "선점 레이스",
      goals: "골",
      cards: "카드",
      correctScore: "정확한 스코어",
      winningMargin: "승리 마진",
      qualify: "예선 통과",
      trophy: "트로피",
      outrightWinner: "아웃라이트 우승",
      cleanSheet: "클린시트",
      firstGoalMethod: "첫 골 방식",
      scoringDraw: "득점 무승부",
      goalLine: "골 라인",
      teamCards: "팀 카드",
      teamCorners: "팀 코너",
      totalCorners: "코너 합계",
      totalCards: "총 카드",
      bookingPoints: "부킹 포인트",
      penaltyAwarded: "페널티 지정",
      shotsOnTarget: "유효슈팅",
      firstGoal: "첫 골",
      lastGoal: "마지막 골",
      homeCleanSheet: "홈 클린시트",
      awayCleanSheet: "원정 클린시트",
      gameTotal: "경기 총점"
    }
  },

  "en-SG": {
    common: {
      loading: "Loading...",
      noData: "No data",
      all: "All",
      live: "Live",
      prematch: "Prematch",
      search: "Search",
      filter: "Filter",
      refresh: "Refresh",
      reset: "Reset",
      apply: "Apply",
      save: "Save",
      close: "Close",
      clear: "Clear",
      status: "Status",
      match: "Match",
      market: "Market",
      league: "League",
      bookmaker: "Bookmaker",
      bookmakers: "Bookmakers",
      updated: "Updated",
      time: "Time",
      date: "Date",
      home: "Home",
      away: "Away",
      score: "Score",
      odds: "Odds",
      oddsLabel: "Odds",
      trueOddsLabel: "True Odds",
      stake: "Stake",
      profit: "Profit",
      payout: "Payout",
      roi: "ROI",
      notes: "Notes",
      today: "Today",
      yesterday: "Yesterday",
      tomorrow: "Tomorrow",
      favorites: "Favorites",
      addFavorite: "Add favourite",
      removeFavorite: "Remove favourite",
      line: "Line",
      selection: "Selection",
      middle: "Middle",
      middleWindow: "Middle window",
      corridor: "Corridor",
      legs: "Legs",
      pick: "Pick",
      picks: "Picks",
      copied: "Copied"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Arbitrage",
      value: "Value Bets",
      notes: "Notes"
    },
    header: {
      logout: "Logout",
      language: "Language"
    },
    sports: {
      football: "Football",
      tennis: "Tennis",
      basketball: "Basketball",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Track rapid odds movement across markets",
      highMove: "High Move",
      steamStrength: "Steam Strength",
      movePercent: "Move %",
      openingOdds: "Opening Odds",
      currentOdds: "Current Odds",
      directionUp: "Up",
      directionDown: "Down",
      directionFlat: "Flat",
      sharpSignal: "Sharp Signal",
      publicSignal: "Public Signal",
      confidence: "Confidence",
      marketType: "Market Type",
      overUnder: "Over/Under",
      handicap: "Handicap",
      moneyline: "Moneyline",
      noSteam: "No steam move found",
      tierYellow: "Yellow",
      tierOrange: "Orange",
      tierGreen: "Green",
      chipBettingSplits: "Betting splits",
      chipMovement: "Movement",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Yellow",
      signalLabelOrange: "Steam · Orange",
      signalLabelGreen: "Steam · Green",
      reasonYellow: "Public handle and bet share diverge; splits-only tier.",
      reasonOrange: "Splits plus confirmed odds movement.",
      reasonGreen: "Splits, movement, Pinnacle-confirmed EV row, and positive EV align.",
      splitsLabel: "Money",
      betsLabel: "Bets",
      splitsGapLabel: "Gap",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Movement",
      bettingSplitsLabel: "Betting splits",
      movementConfirmedLabel: "Movement confirmed",
      pinnacleConfirmedLabel: "Pinnacle confirmed",
      positiveEvLabel: "Positive EV",
      previewLabel: "Preview",
      previewReasonYellow: "Example: splits-only (yellow).",
      previewReasonOrange: "Example: splits plus movement (orange).",
      previewReasonGreen: "Example: full green alignment.",
      previewLeagueSplits: "Preview League — Splits",
      previewLeagueMove: "Preview League — Move",
      previewLeagueEv: "Preview League — EV",
      previewMatchSplits: "Mock United vs Preview City",
      previewMatchMove: "Line Move FC vs Steam Town",
      previewMatchEv: "Sharp Side vs Devig Athletic",
      previewBookA: "BetPreview",
      previewBookB: "MoveLine",
      previewBookC: "ConfirmBook",
      previewSplitsBookConsensus: "Consensus",
      previewSplitsBookMarket: "Market"
    },
    middles: {
      previewWindowThreeGoals: "3 goals",
      previewCorridorOnePt: "1.0 pt corridor",
      previewWindowRounds2122: "21–22 rounds"
    },
    arbitrage: {
      title: "Arbitrage",
      subtitle: "Find risk-free opportunities",
      profitPercent: "Profit %",
      totalStake: "Total Stake",
      guaranteedProfit: "Guaranteed Profit",
      stakeSplit: "Stake Split",
      bestOdds: "Best Odds",
      opportunity: "Opportunity",
      noArb: "No arbitrage opportunities found",
      compareBookmakers: "Compare bookmakers",
      groupA: "Group A",
      groupB: "Group B",
      autoOn: "Auto ON",
      autoOff: "Auto OFF",
      autoOnShort: "Auto: ON",
      autoOffShort: "Auto: OFF",
      last: "Last",
      clearA: "Clear A",
      clearB: "Clear B",
      pause: "Pause",
      resume: "Resume",
      scan: "Scan",
      scanning: "Scanning...",
      selectBookmakers: "Select bookmakers...",
      swapGroups: "Swap A ↔ B",
      disconnected: "Disconnected",
      retainedData: "Retained data",
      liveFeed: "Live feed",
      freshBatch: "Fresh",
      apiDisconnected: "API disconnected",
      backendError: "Backend reported an error",
      fetchError: "Fetch error",
      noArbitrageInPool: "No arbitrage in pool"
    },
    value: {
      title: "Value Bets",
      subtitle: "Compare market price with fair probability",
      valuePercent: "Value %",
      fairOdds: "Fair Odds",
      edge: "Edge",
      expectedValue: "Expected Value",
      trueOdds: "True Odds",
      modelOdds: "Model Odds",
      recommendation: "Recommendation",
      strongValue: "Strong Value",
      mediumValue: "Medium Value",
      lowValue: "Low Value",
      noValue: "No value bets found"
    },
    stats: {
      title: "Notes",
      subtitle: "Tracking and performance overview",
      totalBets: "Total Bets",
      winRate: "Win Rate",
      averageOdds: "Average Odds",
      netProfit: "Net Profit",
      performance: "Performance",
      history: "History",
      recentActivity: "Recent Activity",
      emptyNotes: "No notes available"
    },
    marketTerms: {
      firstHalf: "First half",
      secondHalf: "Second half",
      first10Min: "First 10 minutes",
      first15Min: "First 15 minutes",
      thirtyMinutes: "30 minutes",
      sixtyMinutes: "60 minutes",
      corners: "Corners",
      teamTotal: "Team total",
      exactGoals: "Exact goals",
      drawNoBet: "Draw no bet",
      doubleChance: "Double chance",
      winToNil: "Win to nil",
      oddEven: "Odd / even",
      handicapResult: "Handicap result",
      europeanHandicap: "European handicap",
      firstToScore: "First to score",
      scoreFirst: "Score first",
      scoreLast: "Score last",
      bothHalves: "Both halves",
      eitherHalf: "Either half",
      totalGoalsAndBtts: "Total goals / both teams to score",
      homeTeam: "Home team",
      awayTeam: "Away team",
      raceTo: "Race to",
      goals: "Goals",
      cards: "Cards",
      correctScore: "Correct score",
      winningMargin: "Winning margin",
      qualify: "Qualify",
      trophy: "Trophy",
      outrightWinner: "Outright winner",
      cleanSheet: "Clean sheet",
      firstGoalMethod: "First goal method",
      scoringDraw: "Scoring draw",
      goalLine: "Goal line",
      teamCards: "Team cards",
      teamCorners: "Team corners",
      totalCorners: "Total corners",
      totalCards: "Total cards",
      bookingPoints: "Booking points",
      penaltyAwarded: "Penalty awarded",
      shotsOnTarget: "Shots on target",
      firstGoal: "First goal",
      lastGoal: "Last goal",
      homeCleanSheet: "Home clean sheet",
      awayCleanSheet: "Away clean sheet",
      gameTotal: "Game total"
    }
  },

  "id-ID": {
    common: {
      loading: "Memuat...",
      noData: "Tidak ada data",
      all: "Semua",
      live: "Live",
      prematch: "Pra-pertandingan",
      search: "Cari",
      filter: "Filter",
      refresh: "Segarkan",
      reset: "Atur Ulang",
      apply: "Terapkan",
      save: "Simpan",
      close: "Tutup",
      clear: "Bersihkan",
      status: "Status",
      match: "Pertandingan",
      market: "Pasar",
      league: "Liga",
      bookmaker: "Bandar",
      bookmakers: "Bandar",
      updated: "Diperbarui",
      time: "Waktu",
      date: "Tanggal",
      home: "Tuan Rumah",
      away: "Tandang",
      score: "Skor",
      odds: "Odds",
      oddsLabel: "Odds",
      trueOddsLabel: "Odds Sebenarnya",
      stake: "Taruhan",
      profit: "Keuntungan",
      payout: "Pembayaran",
      roi: "ROI",
      notes: "Catatan",
      today: "Hari Ini",
      yesterday: "Kemarin",
      tomorrow: "Besok",
      favorites: "Favorit",
      addFavorite: "Tambah ke favorit",
      removeFavorite: "Hapus dari favorit",
      line: "Garis",
      selection: "Pilihan",
      middle: "Middle",
      middleWindow: "Jendela middle",
      corridor: "Koridor",
      legs: "Cabang",
      pick: "Pilihan",
      picks: "Pilihan",
      copied: "Disalin"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Arbitrase",
      value: "Taruhan Bernilai",
      notes: "Catatan"
    },
    header: {
      logout: "Keluar",
      language: "Bahasa"
    },
    sports: {
      football: "Sepak Bola",
      tennis: "Tenis",
      basketball: "Basket",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Lacak pergerakan odds yang cepat di berbagai pasar",
      highMove: "Pergerakan Tinggi",
      steamStrength: "Kekuatan Steam",
      movePercent: "Pergerakan %",
      openingOdds: "Odds Awal",
      currentOdds: "Odds Saat Ini",
      directionUp: "Naik",
      directionDown: "Turun",
      directionFlat: "Datar",
      sharpSignal: "Sinyal Sharp",
      publicSignal: "Sinyal Publik",
      confidence: "Kepercayaan",
      marketType: "Tipe Pasar",
      overUnder: "Atas/Bawah",
      handicap: "Handicap",
      moneyline: "Moneyline",
      noSteam: "Tidak ada steam move ditemukan",
      tierYellow: "Kuning",
      tierOrange: "Oranye",
      tierGreen: "Hijau",
      chipBettingSplits: "Split taruhan",
      chipMovement: "Pergerakan",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Kuning",
      signalLabelOrange: "Steam · Oranye",
      signalLabelGreen: "Steam · Hijau",
      reasonYellow: "Volume dan porsi taruhan berbeda; hanya split.",
      reasonOrange: "Split dan pergerakan odds terkonfirmasi.",
      reasonGreen: "Split, pergerakan, baris EV Pinnacle, dan EV positif selaras.",
      splitsLabel: "Uang",
      betsLabel: "Taruhan",
      splitsGapLabel: "Selisih",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Pergerakan",
      bettingSplitsLabel: "Split taruhan",
      movementConfirmedLabel: "Pergerakan dikonfirmasi",
      pinnacleConfirmedLabel: "Pinnacle dikonfirmasi",
      positiveEvLabel: "EV positif",
      previewLabel: "Pratinjau",
      previewReasonYellow: "Contoh: hanya split (kuning).",
      previewReasonOrange: "Contoh: split + pergerakan (oranye).",
      previewReasonGreen: "Contoh: selaras hijau penuh."
    },
    arbitrage: {
      title: "Arbitrase",
      subtitle: "Temukan peluang tanpa risiko",
      profitPercent: "Keuntungan %",
      totalStake: "Total Taruhan",
      guaranteedProfit: "Keuntungan Terjamin",
      stakeSplit: "Pembagian Taruhan",
      bestOdds: "Odds Terbaik",
      opportunity: "Peluang",
      noArb: "Tidak ada peluang arbitrase ditemukan",
      compareBookmakers: "Bandingkan bandar",
      groupA: "Grup A",
      groupB: "Grup B",
      autoOn: "Auto ON",
      autoOff: "Auto OFF",
      autoOnShort: "Auto: ON",
      autoOffShort: "Auto: OFF",
      last: "Terakhir",
      clearA: "Bersihkan A",
      clearB: "Bersihkan B",
      pause: "Jeda",
      resume: "Lanjutkan",
      scan: "Pindai",
      scanning: "Memindai...",
      selectBookmakers: "Pilih bandar...",
      swapGroups: "Tukar A ↔ B",
      disconnected: "Terputus",
      retainedData: "Data tersimpan",
      liveFeed: "Umpan langsung",
      freshBatch: "Terbaru",
      apiDisconnected: "API terputus",
      backendError: "Kesalahan server",
      fetchError: "Gagal memuat",
      noArbitrageInPool: "Tidak ada arbitrase di pool"
    },
    value: {
      title: "Taruhan Bernilai",
      subtitle: "Bandingkan harga pasar dengan probabilitas wajar",
      valuePercent: "Nilai %",
      fairOdds: "Odds Wajar",
      edge: "Keunggulan",
      expectedValue: "Nilai Harapan",
      trueOdds: "Odds Sebenarnya",
      modelOdds: "Odds Model",
      recommendation: "Rekomendasi",
      strongValue: "Nilai Tinggi",
      mediumValue: "Nilai Sedang",
      lowValue: "Nilai Rendah",
      noValue: "Tidak ada taruhan bernilai ditemukan"
    },
    stats: {
      title: "Catatan",
      subtitle: "Pelacakan dan gambaran performa",
      totalBets: "Total Taruhan",
      winRate: "Tingkat Menang",
      averageOdds: "Rata-rata Odds",
      netProfit: "Keuntungan Bersih",
      performance: "Performa",
      history: "Riwayat",
      recentActivity: "Aktivitas Terbaru",
      emptyNotes: "Tidak ada catatan"
    },
    marketTerms: {
      firstHalf: "Babak pertama",
      secondHalf: "Babak kedua",
      first10Min: "10 menit pertama",
      first15Min: "15 menit pertama",
      thirtyMinutes: "30 menit",
      sixtyMinutes: "60 menit",
      corners: "Tendangan sudut",
      teamTotal: "Total tim",
      exactGoals: "Jumlah gol tepat",
      drawNoBet: "Tanpa seri",
      doubleChance: "Peluang ganda",
      winToNil: "Menang tanpa kebobolan",
      oddEven: "Ganjil / genap",
      handicapResult: "Hasil handicap",
      europeanHandicap: "Handicap Eropa",
      firstToScore: "Cetak gol dulu",
      scoreFirst: "Gol pertama",
      scoreLast: "Gol terakhir",
      bothHalves: "Kedua babak",
      eitherHalf: "Salah satu babak",
      totalGoalsAndBtts: "Total gol / kedua tim cetak",
      homeTeam: "Tuan rumah",
      awayTeam: "Tandang",
      raceTo: "Balapan ke",
      goals: "Gol",
      cards: "Kartu",
      correctScore: "Skor tepat",
      winningMargin: "Margin kemenangan",
      qualify: "Lolos",
      trophy: "Trofi",
      outrightWinner: "Juara outright",
      cleanSheet: "Clean sheet",
      firstGoalMethod: "Metode gol pertama",
      scoringDraw: "Seri dengan gol",
      goalLine: "Garis gol",
      teamCards: "Kartu tim",
      teamCorners: "Tendangan sudut tim",
      totalCorners: "Total tendangan sudut",
      totalCards: "Total kartu",
      bookingPoints: "Poin booking",
      penaltyAwarded: "Penalti diberikan",
      shotsOnTarget: "Tembakan on target",
      firstGoal: "Gol pertama",
      lastGoal: "Gol terakhir",
      homeCleanSheet: "Clean sheet kandang",
      awayCleanSheet: "Clean sheet tandang",
      gameTotal: "Total pertandingan"
    }
  },

  "nl-NL": {
    common: {
      loading: "Laden...",
      noData: "Geen gegevens",
      all: "Alles",
      live: "Live",
      prematch: "Voorwedstrijd",
      search: "Zoeken",
      filter: "Filter",
      refresh: "Vernieuwen",
      reset: "Resetten",
      apply: "Toepassen",
      save: "Opslaan",
      close: "Sluiten",
      clear: "Wissen",
      status: "Status",
      match: "Wedstrijd",
      market: "Markt",
      league: "Competitie",
      bookmaker: "Bookmaker",
      bookmakers: "Bookmakers",
      updated: "Bijgewerkt",
      time: "Tijd",
      date: "Datum",
      home: "Thuis",
      away: "Uit",
      score: "Score",
      odds: "Odds",
      oddsLabel: "Odds",
      trueOddsLabel: "Werkelijke Odds",
      stake: "Inzet",
      profit: "Winst",
      payout: "Uitbetaling",
      roi: "ROI",
      notes: "Notities",
      today: "Vandaag",
      yesterday: "Gisteren",
      tomorrow: "Morgen",
      favorites: "Favorieten",
      addFavorite: "Toevoegen aan favorieten",
      removeFavorite: "Verwijderen uit favorieten",
      line: "Lijn",
      selection: "Selectie",
      middle: "Middle",
      middleWindow: "Middle-venster",
      corridor: "Corridor",
      legs: "Onderdelen",
      pick: "Keuze",
      picks: "Keuzes",
      copied: "Gekopieerd"
    },
    tabs: {
      steam: "Steam Move",
      arb: "Arbitrage",
      value: "Value Bets",
      notes: "Notities"
    },
    header: {
      logout: "Uitloggen",
      language: "Taal"
    },
    sports: {
      football: "Voetbal",
      tennis: "Tennis",
      basketball: "Basket",
      esports: "Esports"
    },
    steam: {
      title: "Steam Move",
      subtitle: "Volg snelle oddsbewegingen over markten heen",
      highMove: "Hoge Beweging",
      steamStrength: "Steam Sterkte",
      movePercent: "Beweging %",
      openingOdds: "Openingsodds",
      currentOdds: "Huidige Odds",
      directionUp: "Omhoog",
      directionDown: "Omlaag",
      directionFlat: "Vlak",
      sharpSignal: "Sharp Signaal",
      publicSignal: "Publiek Signaal",
      confidence: "Vertrouwen",
      marketType: "Markttype",
      overUnder: "Over/Under",
      handicap: "Handicap",
      moneyline: "Moneyline",
      noSteam: "Geen steam move gevonden",
      tierYellow: "Geel",
      tierOrange: "Oranje",
      tierGreen: "Groen",
      chipBettingSplits: "Weddenschap-splits",
      chipMovement: "Beweging",
      chipPinnacle: "Pinnacle",
      chipEv: "EV",
      chipEvPositive: "EV+",
      signalLabelYellow: "Steam · Geel",
      signalLabelOrange: "Steam · Oranje",
      signalLabelGreen: "Steam · Groen",
      reasonYellow: "Volume en weddeel wijken; alleen splits.",
      reasonOrange: "Splits plus bevestigde oddsbeweging.",
      reasonGreen: "Splits, beweging, Pinnacle-EV-regel en positieve EV komen overeen.",
      splitsLabel: "Geld",
      betsLabel: "Weddenschappen",
      splitsGapLabel: "Verschil",
      sharpDevigLabel: "Sharp / Devig",
      evLabel: "EV",
      movementLabel: "Beweging",
      bettingSplitsLabel: "Weddenschap-splits",
      movementConfirmedLabel: "Beweging bevestigd",
      pinnacleConfirmedLabel: "Pinnacle bevestigd",
      positiveEvLabel: "Positieve EV",
      previewLabel: "Voorbeeld",
      previewReasonYellow: "Voorbeeld: alleen splits (geel).",
      previewReasonOrange: "Voorbeeld: splits + beweging (oranje).",
      previewReasonGreen: "Voorbeeld: volledige groene match."
    },
    arbitrage: {
      title: "Arbitrage",
      subtitle: "Vind risicoloze kansen",
      profitPercent: "Winst %",
      totalStake: "Totale Inzet",
      guaranteedProfit: "Gegarandeerde Winst",
      stakeSplit: "Inzetverdeling",
      bestOdds: "Beste Odds",
      opportunity: "Kans",
      noArb: "Geen arbitragemogelijkheden gevonden",
      compareBookmakers: "Vergelijk bookmakers",
      groupA: "Groep A",
      groupB: "Groep B",
      autoOn: "Auto ON",
      autoOff: "Auto OFF",
      autoOnShort: "Auto: ON",
      autoOffShort: "Auto: OFF",
      last: "Laatste",
      clearA: "Wis A",
      clearB: "Wis B",
      pause: "Pauze",
      resume: "Hervatten",
      scan: "Scannen",
      scanning: "Scannen...",
      selectBookmakers: "Selecteer bookmakers...",
      swapGroups: "Wissel A ↔ B",
      disconnected: "Verbroken",
      retainedData: "Bewaarde data",
      liveFeed: "Livefeed",
      freshBatch: "Vers",
      apiDisconnected: "API verbinding verbroken",
      backendError: "Serverfout",
      fetchError: "Laadfout",
      noArbitrageInPool: "Geen arbitrage in pool"
    },
    value: {
      title: "Value Bets",
      subtitle: "Vergelijk marktprijs met eerlijke waarschijnlijkheid",
      valuePercent: "Waarde %",
      fairOdds: "Eerlijke Odds",
      edge: "Voordeel",
      expectedValue: "Verwachte Waarde",
      trueOdds: "Werkelijke Odds",
      modelOdds: "Model Odds",
      recommendation: "Aanbeveling",
      strongValue: "Hoge Waarde",
      mediumValue: "Gemiddelde Waarde",
      lowValue: "Lage Waarde",
      noValue: "Geen value bets gevonden"
    },
    stats: {
      title: "Notities",
      subtitle: "Tracking en prestatieoverzicht",
      totalBets: "Totaal Aantal Bets",
      winRate: "Winstpercentage",
      averageOdds: "Gemiddelde Odds",
      netProfit: "Netto Winst",
      performance: "Prestatie",
      history: "Geschiedenis",
      recentActivity: "Recente Activiteit",
      emptyNotes: "Geen notities beschikbaar"
    },
    marketTerms: {
      firstHalf: "1e helft",
      secondHalf: "2e helft",
      first10Min: "Eerste 10 minuten",
      first15Min: "Eerste 15 minuten",
      thirtyMinutes: "30 minuten",
      sixtyMinutes: "60 minuten",
      corners: "Hoekschoppen",
      teamTotal: "Teamtotaal",
      exactGoals: "Exact aantal doelpunten",
      drawNoBet: "Gelijkspel = inzet terug",
      doubleChance: "Dubbele kans",
      winToNil: "Winst zonder tegendoelpunt",
      oddEven: "Oneven / even",
      handicapResult: "Handicapresultaat",
      europeanHandicap: "Europees handicap",
      firstToScore: "Eerste die scoort",
      scoreFirst: "Eerste goal",
      scoreLast: "Laatste goal",
      bothHalves: "Beide helften",
      eitherHalf: "Eén helft",
      totalGoalsAndBtts: "Totaal doelpunten / beide teams scoren",
      homeTeam: "Thuis",
      awayTeam: "Uit",
      raceTo: "Race naar",
      goals: "Doelpunten",
      cards: "Kaarten",
      correctScore: "Correcte score",
      winningMargin: "Winnende marge",
      qualify: "Kwalificeren",
      trophy: "Trofee",
      outrightWinner: "Outright winnaar",
      cleanSheet: "Clean sheet",
      firstGoalMethod: "Manier eerste doelpunt",
      scoringDraw: "Gelijkspel met doelpunten",
      goalLine: "Doellijn",
      teamCards: "Teamkaarten",
      teamCorners: "Team hoekschoppen",
      totalCorners: "Totaal hoekschoppen",
      totalCards: "Totaal kaarten",
      bookingPoints: "Bookingpunten",
      penaltyAwarded: "Strafschop gegeven",
      shotsOnTarget: "Schoten op doel",
      firstGoal: "Eerste doelpunt",
      lastGoal: "Laatste doelpunt",
      homeCleanSheet: "Thuis clean sheet",
      awayCleanSheet: "Uit clean sheet",
      gameTotal: "Totaal wedstrijd"
    }
  }
};

function isPlainObject(value) {
  return value && typeof value === "object" && !Array.isArray(value);
}

function deepMerge(base, override) {
  if (!isPlainObject(base)) return override ?? base;
  const result = { ...base };
  Object.keys(override || {}).forEach((key) => {
    if (isPlainObject(base[key]) && isPlainObject(override[key])) {
      result[key] = deepMerge(base[key], override[key]);
    } else {
      result[key] = override[key];
    }
  });
  return result;
}

function flattenKeys(obj, prefix = "") {
  const out = [];
  Object.keys(obj || {}).forEach((key) => {
    const path = prefix ? `${prefix}.${key}` : key;
    if (isPlainObject(obj[key])) {
      out.push(...flattenKeys(obj[key], path));
    } else {
      out.push(path);
    }
  });
  return out;
}

function valueByPath(obj, path) {
  return path.split(".").reduce((acc, key) => (acc == null ? undefined : acc[key]), obj);
}

function getMissingTranslationKeys(lang) {
  const base = analysisTranslations[ANALYSIS_DEFAULT_LANG] || {};
  const target = analysisTranslations[lang] || {};
  const baseKeys = flattenKeys(base);
  return baseKeys.filter((keyPath) => valueByPath(target, keyPath) == null);
}

function validateAllAnalysisTranslations() {
  const report = {};
  ANALYSIS_LANGS.forEach((lang) => {
    if (lang === ANALYSIS_DEFAULT_LANG) return;
    report[lang] = getMissingTranslationKeys(lang);
  });
  return report;
}

const __analysisMergedCache = new Map();

function getAnalysisTranslationsData(lang) {
  const normalizedLang =
    ANALYSIS_LANGS.includes(lang) ? lang : ANALYSIS_DEFAULT_LANG;

  if (__analysisMergedCache.has(normalizedLang)) {
    return __analysisMergedCache.get(normalizedLang);
  }

  const base = analysisTranslations[ANALYSIS_DEFAULT_LANG] || {};
  const target = analysisTranslations[normalizedLang] || {};
  const merged = deepMerge(base, target);

  __analysisMergedCache.set(normalizedLang, merged);

  return merged;
}

function getAnalysisTextData(lang, group, key, fallback = "") {
  const dict = getAnalysisTranslationsData(lang);
  const value = dict?.[group]?.[key];

  if (value != null && value !== "") return value;

  const baseValue = analysisTranslations?.[ANALYSIS_DEFAULT_LANG]?.[group]?.[key];
  if (baseValue != null && baseValue !== "") return baseValue;

  if (fallback) return fallback;
  return `[missing:${group}.${key}]`;
}

module.exports = {
  ANALYSIS_DEFAULT_LANG,
  ANALYSIS_LANGS,
  analysisTranslations,
  getMissingTranslationKeys,
  validateAllAnalysisTranslations,
  getAnalysisTranslationsData,
  getAnalysisTextData,
};
